
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired477"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    var mod = $parcel$modules[id];
    if (mod !== undefined) {
      return mod.exports;
    }
    var init = $parcel$inits[id];
    if (init !== undefined) {
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired477"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("chO1Z", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::51c2fad80696a752d051082f1f9faaf4>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $024eeefea93f1216$var$_react = $024eeefea93f1216$var$_interopRequireDefault((parcelRequire("42omo")));

var $024eeefea93f1216$var$_baseNew = $024eeefea93f1216$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $024eeefea93f1216$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "File".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: document, file. Do not use to represent a page — use the dedicated 'Page' icon instead.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $024eeefea93f1216$var$FileIcon = (props)=>/*#__PURE__*/ $024eeefea93f1216$var$_react.default.createElement($024eeefea93f1216$var$_baseNew.default, Object.assign({
        name: "FileIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 14a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V5.25c0-.52-.206-1.017-.573-1.384L10.134.573A1.96 1.96 0 0 0 8.75 0H4a2 2 0 0 0-2 2zm2 .5a.5.5 0 0 1-.5-.5V2a.5.5 0 0 1 .5-.5h4v3.75c0 .414.336.75.75.75h3.75v8a.5.5 0 0 1-.5.5zm7.94-10H9.5V2.06z" clip-rule="evenodd"/>`
    }, props));
$024eeefea93f1216$var$FileIcon.displayName = 'FileIcon';
var $024eeefea93f1216$var$_default = module.exports.default = $024eeefea93f1216$var$FileIcon;

});

parcelRegister("aSNrY", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => (parcelRequire("flZlQ")).default);
$parcel$export(module.exports, "Icon", () => (parcelRequire("flZlQ")).Icon);

var $flZlQ = parcelRequire("flZlQ");


});

parcelRegister("flZlQ", function(module, exports) {
/* icon-new.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $578104b7f620e843$var$svgStyles = null;
const $578104b7f620e843$var$iconStyles = null;
const $578104b7f620e843$var$smallIconStyles = null;
const $578104b7f620e843$var$scaleStyles = null; /**
                           * For windows high contrast mode
                           */ 
const $578104b7f620e843$var$baseHcmStyles = null;
const $578104b7f620e843$var$scaleSize = null;
const $578104b7f620e843$var$coreSizeMedium = {
    none: "_1bsbpxbi _4t3ipxbi",
    compact: "_1bsb1ejb _4t3i1ejb",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
const $578104b7f620e843$var$coreSizeSmall = {
    none: "_1bsbutpp _4t3iutpp",
    compact: "_1bsbpxbi _4t3ipxbi",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
const $578104b7f620e843$var$paddingMap = {
    medium: {
        none: 0,
        compact: 4,
        spacious: 4
    },
    small: {
        none: 0,
        compact: 2.66,
        spacious: 8
    }
}; /**
              * __Icon__
              *
              * An icon is used as a visual representation of common actions and commands to provide context.
              *
              * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
              */ 
const $578104b7f620e843$export$f04a61298a47a40f = /*#__PURE__*/ (0, $42omo.memo)(function Icon(props) {
    const { color: color = 'currentColor', testId: testId, label: label, dangerouslySetGlyph: // Used to set icon dimensions/behaviour in codegen
    // Used to set icon glyphs in codegen
    dangerouslySetGlyph, shouldScale: // Used with iconTile to scale icon up and down
    shouldScale, spacing: spacing = 'none', name: name } = props;
    const dangerouslySetInnerHTML = dangerouslySetGlyph ? {
        __html: dangerouslySetGlyph
    } : undefined;
    let size = 'medium';
    if ('size' in props && props.size !== undefined) {
        if (typeof props.size === 'string') size = props.size === 'small' || props.size === 'medium' ? props.size : size;
        else if (name) {
            const newSize = props.size(name);
            size = newSize === 'small' || newSize === 'medium' ? newSize : size;
        }
    }
    const baseSize = 16;
    const viewBoxPadding = $578104b7f620e843$var$paddingMap[size][spacing];
    const viewBoxSize = baseSize + 2 * viewBoxPadding;
    return /*#__PURE__*/ (0, $l998X.jsx)("span", {
        "data-testid": testId,
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            color: color
        },
        className: (0, $gMc0m.default)([
            "_1e0c1o8l _vchhusvi _1o9zidpf _vwz4kb7n _y4ti1igz _bozg1mb9",
            "_12va1onz _jcxd1r8n",
            shouldScale && "_1bsb1kw7 _4t3i1kw7",
            size === 'small' && "_vwz4utpp"
        ]),
        children: /*#__PURE__*/ (0, $l998X.jsx)("svg", {
            fill: "none",
            // we want for Icon Tile
            viewBox: `${0 - viewBoxPadding} ${0 - viewBoxPadding} ${viewBoxSize} ${viewBoxSize}`,
            role: "presentation",
            dangerouslySetInnerHTML: dangerouslySetInnerHTML,
            className: (0, $gMc0m.default)([
                "_1reo15vq _18m915vq _syaz1r31 _lcxvglyw _s7n4yfq0 _vc881r31",
                shouldScale ? "_1bsb1kw7 _4t3i1kw7" : size === 'small' ? $578104b7f620e843$var$coreSizeSmall[spacing] : $578104b7f620e843$var$coreSizeMedium[spacing]
            ])
        })
    });
});
var $578104b7f620e843$export$2e2bcd8739ae039 = $578104b7f620e843$export$f04a61298a47a40f;
module.exports["Icon"] = $578104b7f620e843$export$f04a61298a47a40f;
module.exports["default"] = $578104b7f620e843$export$2e2bcd8739ae039;

});

parcelRegister("9Q2dU", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b170729cb10fdaa6c208ecbe5722b466>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $729ab1e57404246c$var$_react = $729ab1e57404246c$var$_interopRequireDefault((parcelRequire("42omo")));

var $729ab1e57404246c$var$_baseNew = $729ab1e57404246c$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $729ab1e57404246c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "LockLocked".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: secure password in textfields, locked page in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $729ab1e57404246c$var$LockLockedIcon = (props)=>/*#__PURE__*/ $729ab1e57404246c$var$_react.default.createElement($729ab1e57404246c$var$_baseNew.default, Object.assign({
        name: "LockLockedIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5A2.5 2.5 0 0 0 5.5 4v3h5V4A2.5 2.5 0 0 0 8 1.5M12 7V4a4 4 0 0 0-8 0v3a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2M4 8.5a.5.5 0 0 0-.5.5v5a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5V9a.5.5 0 0 0-.5-.5zM7.25 13v-3h1.5v3z" clip-rule="evenodd"/>`
    }, props));
$729ab1e57404246c$var$LockLockedIcon.displayName = 'LockLockedIcon';
var $729ab1e57404246c$var$_default = module.exports.default = $729ab1e57404246c$var$LockLockedIcon;

});

parcelRegister("1bY7o", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4f51e3026bdf0966f56fca36d1a42e0f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0de573c382459987$var$_react = $0de573c382459987$var$_interopRequireDefault((parcelRequire("42omo")));

var $0de573c382459987$var$_baseNew = $0de573c382459987$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $0de573c382459987$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Link".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for links, urls, or copy link.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0de573c382459987$var$LinkIcon = (props)=>/*#__PURE__*/ $0de573c382459987$var$_react.default.createElement($0de573c382459987$var$_baseNew.default, Object.assign({
        name: "LinkIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.22 2.22a3.932 3.932 0 1 1 5.56 5.56l-2.25 2.25-1.06-1.06 2.25-2.25a2.432 2.432 0 0 0-3.44-3.44L7.03 5.53 5.97 4.47zm3.06 3.56-5.5 5.5-1.06-1.06 5.5-5.5zM2.22 8.22l2.25-2.25 1.06 1.06-2.25 2.25a2.432 2.432 0 0 0 3.44 3.44l2.25-2.25 1.06 1.06-2.25 2.25a3.932 3.932 0 1 1-5.56-5.56" clip-rule="evenodd"/>`
    }, props));
$0de573c382459987$var$LinkIcon.displayName = 'LinkIcon';
var $0de573c382459987$var$_default = module.exports.default = $0de573c382459987$var$LinkIcon;

});

parcelRegister("9lz2c", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1df8f3604b71bb3b07e9fa53eb6c9031>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6ce1405572307310$var$_react = $6ce1405572307310$var$_interopRequireDefault((parcelRequire("42omo")));

var $6ce1405572307310$var$_baseNew = $6ce1405572307310$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $6ce1405572307310$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Attachment".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for attaching files to work types or other objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6ce1405572307310$var$AttachmentIcon = (props)=>/*#__PURE__*/ $6ce1405572307310$var$_react.default.createElement($6ce1405572307310$var$_baseNew.default, Object.assign({
        name: "AttachmentIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m5.22 8.47 4.5-4.5 1.06 1.06-4.5 4.5a.664.664 0 0 0 .94.94l4.5-4.5a2.079 2.079 0 0 0-2.94-2.94l-4.5 4.5a3.492 3.492 0 0 0 4.94 4.94l2.5-2.5 1.06 1.06-2.5 2.5a4.993 4.993 0 0 1-7.06-7.06l4.5-4.5a3.578 3.578 0 0 1 5.06 5.06l-4.5 4.5a2.165 2.165 0 0 1-3.06-3.06"/>`
    }, props));
$6ce1405572307310$var$AttachmentIcon.displayName = 'AttachmentIcon';
var $6ce1405572307310$var$_default = module.exports.default = $6ce1405572307310$var$AttachmentIcon;

});

parcelRegister("1yB28", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::33181fb6c3dda951a22e3b4873cc95fe>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1225b183379acbc1$var$_react = $1225b183379acbc1$var$_interopRequireDefault((parcelRequire("42omo")));

var $1225b183379acbc1$var$_baseNew = $1225b183379acbc1$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $1225b183379acbc1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Comment".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for comments on objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $1225b183379acbc1$var$CommentIcon = (props)=>/*#__PURE__*/ $1225b183379acbc1$var$_react.default.createElement($1225b183379acbc1$var$_baseNew.default, Object.assign({
        name: "CommentIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 3.125A2.625 2.625 0 0 1 2.625.5h10.75A2.625 2.625 0 0 1 16 3.125v8.25A2.625 2.625 0 0 1 13.375 14H4.449l-3.327 1.901A.75.75 0 0 1 0 15.25zM2.625 2C2.004 2 1.5 2.504 1.5 3.125v10.833L4.05 12.5h9.325c.621 0 1.125-.504 1.125-1.125v-8.25C14.5 2.504 13.996 2 13.375 2zM12 6.5H4V5h8zm-3 3H4V8h5z" clip-rule="evenodd"/>`
    }, props));
$1225b183379acbc1$var$CommentIcon.displayName = 'CommentIcon';
var $1225b183379acbc1$var$_default = module.exports.default = $1225b183379acbc1$var$CommentIcon;

});

parcelRegister("8cjip", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7d4381d46d56f0396feef6421a091c8f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5f7e698125b9a7f8$var$_react = $5f7e698125b9a7f8$var$_interopRequireDefault((parcelRequire("42omo")));

var $5f7e698125b9a7f8$var$_baseNew = $5f7e698125b9a7f8$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $5f7e698125b9a7f8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "EyeOpen".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: watch page in Confluence, show password in text field, and following in Atlas.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5f7e698125b9a7f8$var$EyeOpenIcon = (props)=>/*#__PURE__*/ $5f7e698125b9a7f8$var$_react.default.createElement($5f7e698125b9a7f8$var$_baseNew.default, Object.assign({
        name: "EyeOpenIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 3.5c-2.943 0-5.49 1.845-6.424 4.396a.3.3 0 0 0 0 .208C2.509 10.655 5.057 12.5 8 12.5s5.49-1.845 6.424-4.396a.3.3 0 0 0 0-.208C13.491 5.345 10.943 3.5 8 3.5M.167 7.38C1.32 4.232 4.433 2 8 2c3.566 0 6.681 2.232 7.833 5.38.146.4.146.84 0 1.24C14.68 11.768 11.566 14 8 14 4.433 14 1.319 11.768.167 8.62a1.8 1.8 0 0 1 0-1.24M8 6.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M5 8a3 3 0 1 1 6 0 3 3 0 0 1-6 0" clip-rule="evenodd"/>`
    }, props));
$5f7e698125b9a7f8$var$EyeOpenIcon.displayName = 'EyeOpenIcon';
var $5f7e698125b9a7f8$var$_default = module.exports.default = $5f7e698125b9a7f8$var$EyeOpenIcon;

});

parcelRegister("9FnLD", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0bf82c15bca1a56d27012abd5cecbc7a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $709a61159e3249e0$var$_react = $709a61159e3249e0$var$_interopRequireDefault((parcelRequire("42omo")));

var $709a61159e3249e0$var$_baseNew = $709a61159e3249e0$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $709a61159e3249e0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ThumbsUp".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: voting options in Jira, like.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $709a61159e3249e0$var$ThumbsUpIcon = (props)=>/*#__PURE__*/ $709a61159e3249e0$var$_react.default.createElement($709a61159e3249e0$var$_baseNew.default, Object.assign({
        name: "ThumbsUpIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.708 2.594a.5.5 0 0 0-.77.15L5.5 7.433V13.5h6.371c.493 0 .928-.32 1.074-.79l1.328-4.25A1.125 1.125 0 0 0 13.2 7H9.75A.75.75 0 0 1 9 6.25V3.075a.5.5 0 0 0-.175-.38zM4 13.5V8H2a.5.5 0 0 0-.5.5V13a.5.5 0 0 0 .5.5zm.295-7 2.313-4.45a2 2 0 0 1 3.076-.596l.118.101a2 2 0 0 1 .698 1.519V5.5h2.7a2.625 2.625 0 0 1 2.505 3.408l-1.328 4.25A2.625 2.625 0 0 1 11.871 15H2a2 2 0 0 1-2-2V8.5a2 2 0 0 1 2-2z" clip-rule="evenodd"/>`
    }, props));
$709a61159e3249e0$var$ThumbsUpIcon.displayName = 'ThumbsUpIcon';
var $709a61159e3249e0$var$_default = module.exports.default = $709a61159e3249e0$var$ThumbsUpIcon;

});

parcelRegister("ci7Ox", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8bb31d7b8eb39bae440b5a0002b7aa63>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8f2d3a379cb5e0d2$var$_react = $8f2d3a379cb5e0d2$var$_interopRequireDefault((parcelRequire("42omo")));

var $8f2d3a379cb5e0d2$var$_baseNew = $8f2d3a379cb5e0d2$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $8f2d3a379cb5e0d2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "QuestionCircle".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: help, tip.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8f2d3a379cb5e0d2$var$QuestionCircleIcon = (props)=>/*#__PURE__*/ $8f2d3a379cb5e0d2$var$_react.default.createElement($8f2d3a379cb5e0d2$var$_baseNew.default, Object.assign({
        name: "QuestionCircleIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m8-3c-.586 0-1 .414-1 1H5.5c0-1.414 1.086-2.5 2.5-2.5s2.5 1.086 2.5 2.5c0 1.133-.713 1.706-1.162 2.058-.511.402-.588.494-.588.692v.75h-1.5v-.75c0-.977.689-1.507 1.078-1.806l.084-.065C8.838 6.544 9 6.367 9 6c0-.586-.414-1-1-1" clip-rule="evenodd"/><path fill="currentcolor" d="M9 11.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/>`
    }, props));
$8f2d3a379cb5e0d2$var$QuestionCircleIcon.displayName = 'QuestionCircleIcon';
var $8f2d3a379cb5e0d2$var$_default = module.exports.default = $8f2d3a379cb5e0d2$var$QuestionCircleIcon;

});

parcelRegister("8jHAi", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a80f298c9d6e0d96eff1b09e3e1e4079>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $60e1e803c59fc672$var$_react = $60e1e803c59fc672$var$_interopRequireDefault((parcelRequire("42omo")));

var $60e1e803c59fc672$var$_baseNew = $60e1e803c59fc672$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $60e1e803c59fc672$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Page".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for pages in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $60e1e803c59fc672$var$PageIcon = (props)=>/*#__PURE__*/ $60e1e803c59fc672$var$_react.default.createElement($60e1e803c59fc672$var$_baseNew.default, Object.assign({
        name: "PageIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5zM12 6H4V4.5h8zm-2 3.5H4V8h6z" clip-rule="evenodd"/>`
    }, props));
$60e1e803c59fc672$var$PageIcon.displayName = 'PageIcon';
var $60e1e803c59fc672$var$_default = module.exports.default = $60e1e803c59fc672$var$PageIcon;

});

parcelRegister("2qVkt", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5af16ea80f1d58312eb2e017eb04c22b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1c5a7ad9346f91a5$var$_react = $1c5a7ad9346f91a5$var$_interopRequireDefault((parcelRequire("42omo")));

var $1c5a7ad9346f91a5$var$_baseNew = $1c5a7ad9346f91a5$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $1c5a7ad9346f91a5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "WorkItem".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for work items.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $1c5a7ad9346f91a5$var$WorkItemIcon = (props)=>/*#__PURE__*/ $1c5a7ad9346f91a5$var$_react.default.createElement($1c5a7ad9346f91a5$var$_baseNew.default, Object.assign({
        name: "WorkItemIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M14.5 4a.5.5 0 0 0-.4-.49L14 3.5H2a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h12a.5.5 0 0 0 .5-.5zm-2.927 1.983-4 4.75a.75.75 0 0 1-1.146 0l-2-2.375 1.146-.966L7 9.085l3.427-4.068zM16 12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h12l.204.01A2 2 0 0 1 16 4z"/>`
    }, props));
$1c5a7ad9346f91a5$var$WorkItemIcon.displayName = 'WorkItemIcon';
var $1c5a7ad9346f91a5$var$_default = module.exports.default = $1c5a7ad9346f91a5$var$WorkItemIcon;

});

parcelRegister("5aaqS", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::411fb0e87ff78661e4fe4f98c48af3ed>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3c25fa9ac9257d0d$var$_react = $3c25fa9ac9257d0d$var$_interopRequireDefault((parcelRequire("42omo")));

var $3c25fa9ac9257d0d$var$_baseNew = $3c25fa9ac9257d0d$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $3c25fa9ac9257d0d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Board".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for boards in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3c25fa9ac9257d0d$var$BoardIcon = (props)=>/*#__PURE__*/ $3c25fa9ac9257d0d$var$_react.default.createElement($3c25fa9ac9257d0d$var$_baseNew.default, Object.assign({
        name: "BoardIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 3.5a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h2.833v-9zm4.333 0v9h3.334v-9zm4.834 0v9H14a.5.5 0 0 0 .5-.5V4a.5.5 0 0 0-.5-.5zM0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2z" clip-rule="evenodd"/>`
    }, props));
$3c25fa9ac9257d0d$var$BoardIcon.displayName = 'BoardIcon';
var $3c25fa9ac9257d0d$var$_default = module.exports.default = $3c25fa9ac9257d0d$var$BoardIcon;

});

parcelRegister("5j8et", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b5b008ccfed50bccf7a8bb78b89f8a48>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3dd51cde97e5ec7d$var$_react = $3dd51cde97e5ec7d$var$_interopRequireDefault((parcelRequire("42omo")));

var $3dd51cde97e5ec7d$var$_baseNew = $3dd51cde97e5ec7d$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $3dd51cde97e5ec7d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Release".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for releases in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3dd51cde97e5ec7d$var$ReleaseIcon = (props)=>/*#__PURE__*/ $3dd51cde97e5ec7d$var$_react.default.createElement($3dd51cde97e5ec7d$var$_baseNew.default, Object.assign({
        name: "ReleaseIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4 2h3v2h2a.75.75 0 0 1 .648.372L11.18 7h4.069a.75.75 0 0 1 .646 1.132l-2.887 4.886a2 2 0 0 1-1.722.982H2a2 2 0 0 1-2-2V7.75A.75.75 0 0 1 .75 7H2V4.75A.75.75 0 0 1 2.75 4H4zm-.5 5h5.944L8.57 5.5H3.5zm-2 1.5V12a.5.5 0 0 0 .5.5h9.287a.5.5 0 0 0 .43-.246L13.936 8.5z" clip-rule="evenodd"/>`
    }, props));
$3dd51cde97e5ec7d$var$ReleaseIcon.displayName = 'ReleaseIcon';
var $3dd51cde97e5ec7d$var$_default = module.exports.default = $3dd51cde97e5ec7d$var$ReleaseIcon;

});

parcelRegister("fZtQj", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ad20bbceb59bcdcbded64441a3f93ce4>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ba43b3b17a3275e6$var$_react = $ba43b3b17a3275e6$var$_interopRequireDefault((parcelRequire("42omo")));

var $ba43b3b17a3275e6$var$_baseNew = $ba43b3b17a3275e6$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $ba43b3b17a3275e6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Image".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: images, image upload.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ba43b3b17a3275e6$var$ImageIcon = (props)=>/*#__PURE__*/ $ba43b3b17a3275e6$var$_react.default.createElement($ba43b3b17a3275e6$var$_baseNew.default, Object.assign({
        name: "ImageIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M5.75 4a1.75 1.75 0 1 1 0 3.5 1.75 1.75 0 0 1 0-3.5"/><path fill="currentcolor" fill-rule="evenodd" d="M13 1a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2zM3 2.5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h.644l6.274-7.723.053-.058a.75.75 0 0 1 1.06 0L13.5 8.19V3a.5.5 0 0 0-.5-.5zm2.575 11H13a.5.5 0 0 0 .5-.5v-2.69l-2.943-2.943z" clip-rule="evenodd"/>`
    }, props));
$ba43b3b17a3275e6$var$ImageIcon.displayName = 'ImageIcon';
var $ba43b3b17a3275e6$var$_default = module.exports.default = $ba43b3b17a3275e6$var$ImageIcon;

});

parcelRegister("2Yaht", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::563b591bbaa180fc5c3a0e9071f2faa1>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $229928ea1c8fbc33$var$_react = $229928ea1c8fbc33$var$_interopRequireDefault((parcelRequire("42omo")));

var $229928ea1c8fbc33$var$_baseNew = $229928ea1c8fbc33$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $229928ea1c8fbc33$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Video".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for representing video content across Atlassian and Loom.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $229928ea1c8fbc33$var$VideoIcon = (props)=>/*#__PURE__*/ $229928ea1c8fbc33$var$_react.default.createElement($229928ea1c8fbc33$var$_baseNew.default, Object.assign({
        name: "VideoIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 4a.5.5 0 0 0-.5.5v7a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5v-7A.5.5 0 0 0 10 4zm-2 .5a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v.218l2.137-1.203A1.25 1.25 0 0 1 16 4.605v6.79a1.25 1.25 0 0 1-1.863 1.09L12 11.282v.218a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm12 5.061 2.5 1.407V5.032L12 6.44z" clip-rule="evenodd"/>`
    }, props));
$229928ea1c8fbc33$var$VideoIcon.displayName = 'VideoIcon';
var $229928ea1c8fbc33$var$_default = module.exports.default = $229928ea1c8fbc33$var$VideoIcon;

});

parcelRegister("1zLiv", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::25c5fc21ffe3de28c11b1ff576772f32>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $125dbf99fbd0a2ae$var$_react = $125dbf99fbd0a2ae$var$_interopRequireDefault((parcelRequire("42omo")));

var $125dbf99fbd0a2ae$var$_baseNew = $125dbf99fbd0a2ae$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $125dbf99fbd0a2ae$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChartBar".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: Bar charts; Reports in JSM, Space Analytics in Confluence
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $125dbf99fbd0a2ae$var$ChartBarIcon = (props)=>/*#__PURE__*/ $125dbf99fbd0a2ae$var$_react.default.createElement($125dbf99fbd0a2ae$var$_baseNew.default, Object.assign({
        name: "ChartBarIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M1 13V1h1.5v12a.5.5 0 0 0 .5.5h12V15H3a2 2 0 0 1-2-2"/><path fill="currentcolor" d="m5.25 8.5.077.004A.75.75 0 0 1 6 9.25v2.5a.75.75 0 0 1-.75.75h-1a.75.75 0 0 1-.75-.75v-2.5a.75.75 0 0 1 .75-.75zm4-3.5a.75.75 0 0 1 .75.75v6a.75.75 0 0 1-.75.75h-1a.75.75 0 0 1-.75-.75v-6A.75.75 0 0 1 8.25 5zm4-3a.75.75 0 0 1 .75.75v9a.75.75 0 0 1-.75.75h-1a.75.75 0 0 1-.75-.75v-9a.75.75 0 0 1 .75-.75z"/>`
    }, props));
$125dbf99fbd0a2ae$var$ChartBarIcon.displayName = 'ChartBarIcon';
var $125dbf99fbd0a2ae$var$_default = module.exports.default = $125dbf99fbd0a2ae$var$ChartBarIcon;

});

parcelRegister("fxBfz", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3ee248cff197501222c434364c4f923a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b506d533fe8a0cdf$var$_react = $b506d533fe8a0cdf$var$_interopRequireDefault((parcelRequire("42omo")));

var $b506d533fe8a0cdf$var$_baseNew = $b506d533fe8a0cdf$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $b506d533fe8a0cdf$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Automation".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved to represent an Automation.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b506d533fe8a0cdf$var$AutomationIcon = (props)=>/*#__PURE__*/ $b506d533fe8a0cdf$var$_react.default.createElement($b506d533fe8a0cdf$var$_baseNew.default, Object.assign({
        name: "AutomationIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M10.377.102a.75.75 0 0 1 .346.847L8.985 7.25h4.265a.75.75 0 0 1 .53 1.28l-7.25 7.25a.75.75 0 0 1-1.253-.73l1.738-6.3H2.75a.75.75 0 0 1-.53-1.28L9.47.22a.75.75 0 0 1 .907-.118M7.43 7.25l1.093-3.96L4.56 7.25zm1.142 1.5-1.093 3.96 3.961-3.96z" clip-rule="evenodd"/>`
    }, props));
$b506d533fe8a0cdf$var$AutomationIcon.displayName = 'AutomationIcon';
var $b506d533fe8a0cdf$var$_default = module.exports.default = $b506d533fe8a0cdf$var$AutomationIcon;

});

parcelRegister("8DN9t", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c44ca3af5d99d99573761123bc1c1f79>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $019f9d4947dadb8d$var$_react = $019f9d4947dadb8d$var$_interopRequireDefault((parcelRequire("42omo")));

var $019f9d4947dadb8d$var$_baseNew = $019f9d4947dadb8d$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $019f9d4947dadb8d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Calendar".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: date metadata, date input field, calendar view, jira status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $019f9d4947dadb8d$var$CalendarIcon = (props)=>/*#__PURE__*/ $019f9d4947dadb8d$var$_react.default.createElement($019f9d4947dadb8d$var$_baseNew.default, Object.assign({
        name: "CalendarIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4.5 2.5v2H6v-2h4v2h1.5v-2H13a.5.5 0 0 1 .5.5v3h-11V3a.5.5 0 0 1 .5-.5zm-2 5V13a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V7.5zm9-6.5H13a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1.5V0H6v1h4V0h1.5z" clip-rule="evenodd"/>`
    }, props));
$019f9d4947dadb8d$var$CalendarIcon.displayName = 'CalendarIcon';
var $019f9d4947dadb8d$var$_default = module.exports.default = $019f9d4947dadb8d$var$CalendarIcon;

});

parcelRegister("cyLm6", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::21d894bc7c6ad9ec58bc8f60f7c17f4b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $924d64d50e830455$var$_react = $924d64d50e830455$var$_interopRequireDefault((parcelRequire("42omo")));

var $924d64d50e830455$var$_baseNew = $924d64d50e830455$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $924d64d50e830455$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChartTrendUp".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: Upward trending data; Trend charts; Reports in Jira; Sprint insights.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $924d64d50e830455$var$ChartTrendUpIcon = (props)=>/*#__PURE__*/ $924d64d50e830455$var$_react.default.createElement($924d64d50e830455$var$_baseNew.default, Object.assign({
        name: "ChartTrendUpIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M1 13V1h1.5v12a.5.5 0 0 0 .5.5h12V15H3a2 2 0 0 1-2-2"/><path fill="currentcolor" d="M15 7.5h-1.5V5.56L9.78 9.28a.75.75 0 0 1-1.06 0L7.25 7.81l-2.22 2.22-1.06-1.06 2.75-2.75.056-.052a.75.75 0 0 1 1.004.052l1.47 1.47 3.19-3.19H10.5V3h3.75a.75.75 0 0 1 .75.75z"/>`
    }, props));
$924d64d50e830455$var$ChartTrendUpIcon.displayName = 'ChartTrendUpIcon';
var $924d64d50e830455$var$_default = module.exports.default = $924d64d50e830455$var$ChartTrendUpIcon;

});

parcelRegister("3HOqx", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::987f1732135eba9300239393b5450485>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2b2c81054261ff66$var$_react = $2b2c81054261ff66$var$_interopRequireDefault((parcelRequire("42omo")));

var $2b2c81054261ff66$var$_baseNew = $2b2c81054261ff66$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $2b2c81054261ff66$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Lightbulb".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: learnings in Atlas.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $2b2c81054261ff66$var$LightbulbIcon = (props)=>/*#__PURE__*/ $2b2c81054261ff66$var$_react.default.createElement($2b2c81054261ff66$var$_baseNew.default, Object.assign({
        name: "LightbulbIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M10 12.5H6V14a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5zm-2-11c-3.022 0-4.935 3.243-3.473 5.888L5.535 9.21c.303.548.463 1.164.465 1.79h4a3.7 3.7 0 0 1 .465-1.79l1.008-1.822C12.935 4.743 11.022 1.5 8 1.5M11.5 14a2 2 0 0 1-2 2h-3a2 2 0 0 1-2-2v-2.988a2.2 2.2 0 0 0-.277-1.075L3.215 8.114C1.2 4.47 3.835 0 8 0c4.164 0 6.8 4.47 4.785 8.114l-1.008 1.823a2.2 2.2 0 0 0-.277 1.075z"/>`
    }, props));
$2b2c81054261ff66$var$LightbulbIcon.displayName = 'LightbulbIcon';
var $2b2c81054261ff66$var$_default = module.exports.default = $2b2c81054261ff66$var$LightbulbIcon;

});

parcelRegister("6fjxX", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0a07179b7f5702563b15bc18315c2436>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $48c34e576a5d6e3c$var$_react = $48c34e576a5d6e3c$var$_interopRequireDefault((parcelRequire("42omo")));

var $48c34e576a5d6e3c$var$_baseNew = $48c34e576a5d6e3c$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $48c34e576a5d6e3c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Megaphone".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: feedback in apps.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $48c34e576a5d6e3c$var$MegaphoneIcon = (props)=>/*#__PURE__*/ $48c34e576a5d6e3c$var$_react.default.createElement($48c34e576a5d6e3c$var$_baseNew.default, Object.assign({
        name: "MegaphoneIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M13.5 3.096a.5.5 0 0 0-.685-.465L7.5 4.756v4.736l5.315 2.126a.5.5 0 0 0 .685-.465zM5 13a.5.5 0 0 0 .5.5H6v-2.75H5zM2.5 8.75a.5.5 0 0 0 .5.5h3V5H3a.5.5 0 0 0-.5.5zM15 11.152a2 2 0 0 1-2.743 1.857L7.5 11.107v3.143a.75.75 0 0 1-.75.75H5.5a2 2 0 0 1-2-2v-2.25H3a2 2 0 0 1-2-2V5.5a2 2 0 0 1 2-2h3.605l5.652-2.261A2 2 0 0 1 15 3.096z"/>`
    }, props));
$48c34e576a5d6e3c$var$MegaphoneIcon.displayName = 'MegaphoneIcon';
var $48c34e576a5d6e3c$var$_default = module.exports.default = $48c34e576a5d6e3c$var$MegaphoneIcon;

});

parcelRegister("6767u", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fc4353a18034f564a0b3573d4163ea60>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0126111c05935b08$var$_react = $0126111c05935b08$var$_interopRequireDefault((parcelRequire("42omo")));

var $0126111c05935b08$var$_baseNew = $0126111c05935b08$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $0126111c05935b08$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Person".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: representing a person or user, owner, contributor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0126111c05935b08$var$PersonIcon = (props)=>/*#__PURE__*/ $0126111c05935b08$var$_react.default.createElement($0126111c05935b08$var$_baseNew.default, Object.assign({
        name: "PersonIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M4 4a4 4 0 1 1 8 0 4 4 0 0 1-8 0m-2 9a3.75 3.75 0 0 1 3.75-3.75h4.5A3.75 3.75 0 0 1 14 13v2h-1.5v-2a2.25 2.25 0 0 0-2.25-2.25h-4.5A2.25 2.25 0 0 0 3.5 13v2H2z" clip-rule="evenodd"/>`
    }, props));
$0126111c05935b08$var$PersonIcon.displayName = 'PersonIcon';
var $0126111c05935b08$var$_default = module.exports.default = $0126111c05935b08$var$PersonIcon;

});

parcelRegister("ebrpi", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2ee7b3f114c675eea0f953c33a485bcf>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a5375a398d03dbd3$var$_react = $a5375a398d03dbd3$var$_interopRequireDefault((parcelRequire("42omo")));

var $a5375a398d03dbd3$var$_baseNew = $a5375a398d03dbd3$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $a5375a398d03dbd3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusWarning".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for warning statuses.
Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a5375a398d03dbd3$var$StatusWarningIcon = (props)=>/*#__PURE__*/ $a5375a398d03dbd3$var$_react.default.createElement($a5375a398d03dbd3$var$_baseNew.default, Object.assign({
        name: "StatusWarningIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.242 1.168c.756-1.395 2.76-1.395 3.516 0l5.9 10.878c.723 1.333-.242 2.953-1.758 2.953H2.1C.584 15-.38 13.38.342 12.046zM8 10.75a1 1 0 1 0 0 2.001 1 1 0 0 0 0-2M7.25 4.5v5h1.5v-5z" clip-rule="evenodd"/>`
    }, props));
$a5375a398d03dbd3$var$StatusWarningIcon.displayName = 'StatusWarningIcon';
var $a5375a398d03dbd3$var$_default = module.exports.default = $a5375a398d03dbd3$var$StatusWarningIcon;

});

parcelRegister("1dKyn", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2f93b4fc46a2af93e5da0e2c365640ac>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0e3b1de532be22c3$var$_react = $0e3b1de532be22c3$var$_interopRequireDefault((parcelRequire("42omo")));

var $0e3b1de532be22c3$var$_baseNew = $0e3b1de532be22c3$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $0e3b1de532be22c3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Teams".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for teams in Atlassian.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0e3b1de532be22c3$var$TeamsIcon = (props)=>/*#__PURE__*/ $0e3b1de532be22c3$var$_react.default.createElement($0e3b1de532be22c3$var$_baseNew.default, Object.assign({
        name: "TeamsIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4 2.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M1 4a3 3 0 1 1 6 0 3 3 0 0 1-6 0m11-1.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M9 4a3 3 0 1 1 6 0 3 3 0 0 1-6 0M3.75 9.5a2.25 2.25 0 0 0-2.25 2.25V13a.5.5 0 0 0 .5.5h4V15H2a2 2 0 0 1-2-2v-1.25A3.75 3.75 0 0 1 3.75 8h1.149a3.75 3.75 0 0 1 3.524 2.469l.564 1.55A2.25 2.25 0 0 0 11.1 13.5H14a.5.5 0 0 0 .5-.5v-1.25a2.25 2.25 0 0 0-2.25-2.25H12c-.775 0-1.258.06-1.531.112-.137.026-.22.05-.26.062l-.027.01.007-.003.01-.004.005-.003.003-.002h.002c.001-.001.001-.001-.334-.672l-.335-.671h.001l.002-.002.004-.001.008-.004.018-.008a1 1 0 0 1 .174-.066q.156-.053.44-.11C10.572 8.065 11.15 8 12 8h.25A3.75 3.75 0 0 1 16 11.75V13a2 2 0 0 1-2 2h-2.899a3.75 3.75 0 0 1-3.524-2.469l-.564-1.55A2.25 2.25 0 0 0 4.9 9.5z" clip-rule="evenodd"/>`
    }, props));
$0e3b1de532be22c3$var$TeamsIcon.displayName = 'TeamsIcon';
var $0e3b1de532be22c3$var$_default = module.exports.default = $0e3b1de532be22c3$var$TeamsIcon;

});

parcelRegister("22Iw9", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fcfd9fc2877ad309c8a5d6e5d6ea9482>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $17ce4cee627292b0$var$_react = $17ce4cee627292b0$var$_interopRequireDefault((parcelRequire("42omo")));

var $17ce4cee627292b0$var$_baseNew = $17ce4cee627292b0$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $17ce4cee627292b0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ArrowDown".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Know uses: sorting table headers or Bitbucket code difference.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $17ce4cee627292b0$var$ArrowDownIcon = (props)=>/*#__PURE__*/ $17ce4cee627292b0$var$_react.default.createElement($17ce4cee627292b0$var$_baseNew.default, Object.assign({
        name: "ArrowDownIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.75 1v11.44l3.72-3.72 1.06 1.06-5 5a.75.75 0 0 1-1.06 0l-5-5 1.06-1.06 3.72 3.72V1z" clip-rule="evenodd"/>`
    }, props));
$17ce4cee627292b0$var$ArrowDownIcon.displayName = 'ArrowDownIcon';
var $17ce4cee627292b0$var$_default = module.exports.default = $17ce4cee627292b0$var$ArrowDownIcon;

});

parcelRegister("bPdpL", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2156d9d42c2a1cee4be11481dce76dec>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $89bedcfc875a52d0$var$_react = $89bedcfc875a52d0$var$_interopRequireDefault((parcelRequire("42omo")));

var $89bedcfc875a52d0$var$_baseNew = $89bedcfc875a52d0$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $89bedcfc875a52d0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ArrowLeft".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: back to previous screen, previous slide.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $89bedcfc875a52d0$var$ArrowLeftIcon = (props)=>/*#__PURE__*/ $89bedcfc875a52d0$var$_react.default.createElement($89bedcfc875a52d0$var$_baseNew.default, Object.assign({
        name: "ArrowLeftIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m1.22 7.47 5-5 1.06 1.06-3.72 3.72H15v1.5H3.56l3.72 3.72-1.06 1.06-5-5a.75.75 0 0 1 0-1.06" clip-rule="evenodd"/>`
    }, props));
$89bedcfc875a52d0$var$ArrowLeftIcon.displayName = 'ArrowLeftIcon';
var $89bedcfc875a52d0$var$_default = module.exports.default = $89bedcfc875a52d0$var$ArrowLeftIcon;

});

parcelRegister("5tOl1", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::702c7642ca2bbc12ec1dc2b75efbc1ea>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $01079791ac69b5c9$var$_react = $01079791ac69b5c9$var$_interopRequireDefault((parcelRequire("42omo")));

var $01079791ac69b5c9$var$_baseNew = $01079791ac69b5c9$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $01079791ac69b5c9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ArrowRight".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: link to nested menu item, a linked menu item, next slide.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $01079791ac69b5c9$var$ArrowRightIcon = (props)=>/*#__PURE__*/ $01079791ac69b5c9$var$_react.default.createElement($01079791ac69b5c9$var$_baseNew.default, Object.assign({
        name: "ArrowRightIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M12.44 7.25 8.72 3.53l1.06-1.06 5 5a.75.75 0 0 1 0 1.06l-5 5-1.06-1.06 3.72-3.72H1v-1.5z" clip-rule="evenodd"/>`
    }, props));
$01079791ac69b5c9$var$ArrowRightIcon.displayName = 'ArrowRightIcon';
var $01079791ac69b5c9$var$_default = module.exports.default = $01079791ac69b5c9$var$ArrowRightIcon;

});

parcelRegister("fCjCI", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5543a1bcdfd8c47fe735784b0d385448>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b5e9a073b74cb7a3$var$_react = $b5e9a073b74cb7a3$var$_interopRequireDefault((parcelRequire("42omo")));

var $b5e9a073b74cb7a3$var$_baseNew = $b5e9a073b74cb7a3$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $b5e9a073b74cb7a3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "EyeOpenFilled".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: watched pages in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b5e9a073b74cb7a3$var$EyeOpenFilledIcon = (props)=>/*#__PURE__*/ $b5e9a073b74cb7a3$var$_react.default.createElement($b5e9a073b74cb7a3$var$_baseNew.default, Object.assign({
        name: "EyeOpenFilledIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M5.75 8a2.25 2.25 0 1 1 4.5 0 2.25 2.25 0 0 1-4.5 0"/><path fill="currentcolor" fill-rule="evenodd" d="M8 2C4.433 2 1.319 4.232.167 7.38c-.146.4-.146.84 0 1.24C1.32 11.768 4.433 14 8 14c3.566 0 6.681-2.232 7.833-5.38.146-.4.146-.84 0-1.24C14.68 4.232 11.566 2 8 2m0 2.25a3.75 3.75 0 1 0 0 7.5 3.75 3.75 0 0 0 0-7.5" clip-rule="evenodd"/>`
    }, props));
$b5e9a073b74cb7a3$var$EyeOpenFilledIcon.displayName = 'EyeOpenFilledIcon';
var $b5e9a073b74cb7a3$var$_default = module.exports.default = $b5e9a073b74cb7a3$var$EyeOpenFilledIcon;

});

parcelRegister("7OYaz", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::baa34f3217bb36f9859c9b6bddb020ad>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5b1be05367c6e6be$var$_react = $5b1be05367c6e6be$var$_interopRequireDefault((parcelRequire("42omo")));

var $5b1be05367c6e6be$var$_baseNew = $5b1be05367c6e6be$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $5b1be05367c6e6be$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PullRequest".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for pull requests.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5b1be05367c6e6be$var$PullRequestIcon = (props)=>/*#__PURE__*/ $5b1be05367c6e6be$var$_react.default.createElement($5b1be05367c6e6be$var$_baseNew.default, Object.assign({
        name: "PullRequestIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4.25 2.5a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5M2 3.25a2.25 2.25 0 1 1 3 2.122v5.256a2.251 2.251 0 1 1-1.5 0V5.372A2.25 2.25 0 0 1 2 3.25m6-.75h1.75a2.75 2.75 0 0 1 2.75 2.75v5.378a2.251 2.251 0 1 1-1.5 0V5.25C11 4.56 10.44 4 9.75 4H8zM4.25 12a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5m7.5 0a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5" clip-rule="evenodd"/>`
    }, props));
$5b1be05367c6e6be$var$PullRequestIcon.displayName = 'PullRequestIcon';
var $5b1be05367c6e6be$var$_default = module.exports.default = $5b1be05367c6e6be$var$PullRequestIcon;

});

parcelRegister("7FcUt", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a3cffb1e2896c4c9b0f7d38ebabc4260>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5946605c631f6a0e$var$_react = $5946605c631f6a0e$var$_interopRequireDefault((parcelRequire("42omo")));

var $5946605c631f6a0e$var$_baseNew = $5946605c631f6a0e$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $5946605c631f6a0e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CheckboxChecked".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Reserved for interactive checkbox experiences. Consider using the checkbox component.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5946605c631f6a0e$var$CheckboxCheckedIcon = (props)=>/*#__PURE__*/ $5946605c631f6a0e$var$_react.default.createElement($5946605c631f6a0e$var$_baseNew.default, Object.assign({
        name: "CheckboxCheckedIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M3 1a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2zm9.326 4.48-1.152-.96L6.75 9.828 4.826 7.52l-1.152.96 2.5 3a.75.75 0 0 0 1.152 0z" clip-rule="evenodd"/>`
    }, props));
$5946605c631f6a0e$var$CheckboxCheckedIcon.displayName = 'CheckboxCheckedIcon';
var $5946605c631f6a0e$var$_default = module.exports.default = $5946605c631f6a0e$var$CheckboxCheckedIcon;

});

parcelRegister("cvXh8", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::bcf60af7e41b379d3a36d6fe455c57ca>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $91c65c25a9968649$var$_react = $91c65c25a9968649$var$_interopRequireDefault((parcelRequire("42omo")));

var $91c65c25a9968649$var$_baseNew = $91c65c25a9968649$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $91c65c25a9968649$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CheckMark".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: table cells, checkboxes.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $91c65c25a9968649$var$CheckMarkIcon = (props)=>/*#__PURE__*/ $91c65c25a9968649$var$_react.default.createElement($91c65c25a9968649$var$_baseNew.default, Object.assign({
        name: "CheckMarkIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m13.959 3.97-7.25 9a.75.75 0 0 1-1.163.007l-3.5-4.25 1.158-.954 2.914 3.539 6.673-8.283z"/>`
    }, props));
$91c65c25a9968649$var$CheckMarkIcon.displayName = 'CheckMarkIcon';
var $91c65c25a9968649$var$_default = module.exports.default = $91c65c25a9968649$var$CheckMarkIcon;

});

parcelRegister("ghftu", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d56e8662eb8a8d2462ec3a39ff3aa40b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bd9a3cd17c99332c$var$_react = $bd9a3cd17c99332c$var$_interopRequireDefault((parcelRequire("42omo")));

var $bd9a3cd17c99332c$var$_baseNew = $bd9a3cd17c99332c$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $bd9a3cd17c99332c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronDown".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
Known uses: Open dropdown menu, expanded tree item, collapse tree item
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $bd9a3cd17c99332c$var$ChevronDownIcon = (props)=>/*#__PURE__*/ $bd9a3cd17c99332c$var$_react.default.createElement($bd9a3cd17c99332c$var$_baseNew.default, Object.assign({
        name: "ChevronDownIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m14.53 6.03-6 6a.75.75 0 0 1-1.004.052l-.056-.052-6-6 1.06-1.06L8 10.44l5.47-5.47z"/>`
    }, props));
$bd9a3cd17c99332c$var$ChevronDownIcon.displayName = 'ChevronDownIcon';
var $bd9a3cd17c99332c$var$_default = module.exports.default = $bd9a3cd17c99332c$var$ChevronDownIcon;

});

parcelRegister("1utEm", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::bb13eaa5526967aa7dd1d436cdcfea10>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $115f97a594d18f06$var$_react = $115f97a594d18f06$var$_interopRequireDefault((parcelRequire("42omo")));

var $115f97a594d18f06$var$_baseNew = $115f97a594d18f06$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $115f97a594d18f06$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChildWorkItems".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for child work items.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $115f97a594d18f06$var$ChildWorkItemsIcon = (props)=>/*#__PURE__*/ $115f97a594d18f06$var$_react.default.createElement($115f97a594d18f06$var$_baseNew.default, Object.assign({
        name: "ChildWorkItemsIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M8.5 13.5h5V11h-5zm0-7h5V4h-5zm6.5.25C15 7.44 14.44 8 13.75 8h-5.5C7.56 8 7 7.44 7 6.75V6H2.5v5a.5.5 0 0 0 .5.5h4v-.75c0-.69.56-1.25 1.25-1.25h5.5c.69 0 1.25.56 1.25 1.25v3c0 .69-.56 1.25-1.25 1.25h-5.5C7.56 15 7 14.44 7 13.75V13H3a2 2 0 0 1-2-2V1h1.5v3.5H7v-.75c0-.69.56-1.25 1.25-1.25h5.5c.69 0 1.25.56 1.25 1.25z"/>`
    }, props));
$115f97a594d18f06$var$ChildWorkItemsIcon.displayName = 'ChildWorkItemsIcon';
var $115f97a594d18f06$var$_default = module.exports.default = $115f97a594d18f06$var$ChildWorkItemsIcon;

});

parcelRegister("1Zr9M", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::63ac376f9836d1894f72051899adf679>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $17308db967ef8257$var$_react = $17308db967ef8257$var$_interopRequireDefault((parcelRequire("42omo")));

var $17308db967ef8257$var$_baseNew = $17308db967ef8257$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $17308db967ef8257$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Edit".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for editing objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $17308db967ef8257$var$EditIcon = (props)=>/*#__PURE__*/ $17308db967ef8257$var$_react.default.createElement($17308db967ef8257$var$_baseNew.default, Object.assign({
        name: "EditIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M11.586.854a2 2 0 0 1 2.828 0l.732.732a2 2 0 0 1 0 2.828L10.01 9.551a2 2 0 0 1-.864.51l-3.189.91a.75.75 0 0 1-.927-.927l.91-3.189a2 2 0 0 1 .51-.864zm1.768 1.06a.5.5 0 0 0-.708 0l-.585.586L13.5 3.94l.586-.586a.5.5 0 0 0 0-.708zM12.439 5 11 3.56 7.51 7.052a.5.5 0 0 0-.128.216l-.54 1.891 1.89-.54a.5.5 0 0 0 .217-.127zM3 2.501a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V10H15v3.001a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-10a2 2 0 0 1 2-2h3v1.5z" clip-rule="evenodd"/>`
    }, props));
$17308db967ef8257$var$EditIcon.displayName = 'EditIcon';
var $17308db967ef8257$var$_default = module.exports.default = $17308db967ef8257$var$EditIcon;

});

parcelRegister("1dusJ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6cb88e2f2689b833163eb837a986d615>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0e2ea287089b1269$var$_react = $0e2ea287089b1269$var$_interopRequireDefault((parcelRequire("42omo")));

var $0e2ea287089b1269$var$_baseNew = $0e2ea287089b1269$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $0e2ea287089b1269$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AlignImageLeft".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for left aligning media and content.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0e2ea287089b1269$var$AlignImageLeftIcon = (props)=>/*#__PURE__*/ $0e2ea287089b1269$var$_react.default.createElement($0e2ea287089b1269$var$_baseNew.default, Object.assign({
        name: "AlignImageLeftIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M15 2.5H1V1h14zm-12.5 4v3h3v-3zM2.375 5h3.25C6.385 5 7 5.616 7 6.375v3.25C7 10.385 6.384 11 5.625 11h-3.25C1.615 11 1 10.384 1 9.625v-3.25C1 5.615 1.616 5 2.375 5M15 15H1v-1.5h14z" clip-rule="evenodd"/>`
    }, props));
$0e2ea287089b1269$var$AlignImageLeftIcon.displayName = 'AlignImageLeftIcon';
var $0e2ea287089b1269$var$_default = module.exports.default = $0e2ea287089b1269$var$AlignImageLeftIcon;

});

parcelRegister("9Y9Mx", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7bbc09938ed9e286f5042595c4dccad5>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $74214e1ec9117b99$var$_react = $74214e1ec9117b99$var$_interopRequireDefault((parcelRequire("42omo")));

var $74214e1ec9117b99$var$_baseNew = $74214e1ec9117b99$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $74214e1ec9117b99$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AlignImageRight".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for right aligning media and content.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $74214e1ec9117b99$var$AlignImageRightIcon = (props)=>/*#__PURE__*/ $74214e1ec9117b99$var$_react.default.createElement($74214e1ec9117b99$var$_baseNew.default, Object.assign({
        name: "AlignImageRightIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M15 2.5H1V1h14zm-4.5 4v3h3v-3zM10.375 5h3.25C14.385 5 15 5.616 15 6.375v3.25c0 .76-.616 1.375-1.375 1.375h-3.25C9.615 11 9 10.384 9 9.625v-3.25C9 5.615 9.616 5 10.375 5M15 15H1v-1.5h14z" clip-rule="evenodd"/>`
    }, props));
$74214e1ec9117b99$var$AlignImageRightIcon.displayName = 'AlignImageRightIcon';
var $74214e1ec9117b99$var$_default = module.exports.default = $74214e1ec9117b99$var$AlignImageRightIcon;

});

parcelRegister("hmuev", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::13080645a1b889dca339823c8ecd9929>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ca3bf15ae8c7c28f$var$_react = $ca3bf15ae8c7c28f$var$_interopRequireDefault((parcelRequire("42omo")));

var $ca3bf15ae8c7c28f$var$_baseNew = $ca3bf15ae8c7c28f$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $ca3bf15ae8c7c28f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Cross".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: closing modals, panels, and transient views; removing tags
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ca3bf15ae8c7c28f$var$CrossIcon = (props)=>/*#__PURE__*/ $ca3bf15ae8c7c28f$var$_react.default.createElement($ca3bf15ae8c7c28f$var$_baseNew.default, Object.assign({
        name: "CrossIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M14.03 3.03 9.06 8l4.97 4.97-1.06 1.06L8 9.06l-4.97 4.97-1.06-1.06L6.94 8 1.97 3.03l1.06-1.06L8 6.94l4.97-4.97z"/>`
    }, props));
$ca3bf15ae8c7c28f$var$CrossIcon.displayName = 'CrossIcon';
var $ca3bf15ae8c7c28f$var$_default = module.exports.default = $ca3bf15ae8c7c28f$var$CrossIcon;

});

parcelRegister("64M9v", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2fe612b077f89273578622d0011caa3a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $46c877d9e4f2db1d$var$_react = $46c877d9e4f2db1d$var$_interopRequireDefault((parcelRequire("42omo")));

var $46c877d9e4f2db1d$var$_baseNew = $46c877d9e4f2db1d$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $46c877d9e4f2db1d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ShrinkHorizontal".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for contracting or reducing the width of an element.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $46c877d9e4f2db1d$var$ShrinkHorizontalIcon = (props)=>/*#__PURE__*/ $46c877d9e4f2db1d$var$_react.default.createElement($46c877d9e4f2db1d$var$_baseNew.default, Object.assign({
        name: "ShrinkHorizontalIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.25 8.75H0v-1.5h6.25zm3.5-1.5H16v1.5H9.75z" clip-rule="evenodd"/><path fill="currentcolor" fill-rule="evenodd" d="M5.19 8 2.22 5.03l1.06-1.06 3.5 3.5a.75.75 0 0 1 0 1.06l-3.5 3.5-1.06-1.06zm4.03-.53 3.5-3.5 1.06 1.06L10.81 8l2.97 2.97-1.06 1.06-3.5-3.5a.75.75 0 0 1 0-1.06" clip-rule="evenodd"/>`
    }, props));
$46c877d9e4f2db1d$var$ShrinkHorizontalIcon.displayName = 'ShrinkHorizontalIcon';
var $46c877d9e4f2db1d$var$_default = module.exports.default = $46c877d9e4f2db1d$var$ShrinkHorizontalIcon;

});

parcelRegister("5Yp2m", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::efc4ad949a44efb0684f52ead162d030>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4595fa2a3e3f9b8e$var$_react = $4595fa2a3e3f9b8e$var$_interopRequireDefault((parcelRequire("42omo")));

var $4595fa2a3e3f9b8e$var$_baseNew = $4595fa2a3e3f9b8e$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $4595fa2a3e3f9b8e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Minus".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: horizontal rule in Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $4595fa2a3e3f9b8e$var$MinusIcon = (props)=>/*#__PURE__*/ $4595fa2a3e3f9b8e$var$_react.default.createElement($4595fa2a3e3f9b8e$var$_baseNew.default, Object.assign({
        name: "MinusIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M15 8.75H1v-1.5h14z" clip-rule="evenodd"/>`
    }, props));
$4595fa2a3e3f9b8e$var$MinusIcon.displayName = 'MinusIcon';
var $4595fa2a3e3f9b8e$var$_default = module.exports.default = $4595fa2a3e3f9b8e$var$MinusIcon;

});

parcelRegister("9eEg2", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f1c30d577c7234bb5109e7b6cea91ee6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6b94a631f0b72fed$var$_react = $6b94a631f0b72fed$var$_interopRequireDefault((parcelRequire("42omo")));

var $6b94a631f0b72fed$var$_baseNew = $6b94a631f0b72fed$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $6b94a631f0b72fed$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Emoji".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for Editor as a category for Emoji's.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6b94a631f0b72fed$var$EmojiIcon = (props)=>/*#__PURE__*/ $6b94a631f0b72fed$var$_react.default.createElement($6b94a631f0b72fed$var$_baseNew.default, Object.assign({
        name: "EmojiIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m4.5-1.75a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0m4.5 0a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0m-2.915 3.783c.486.378 1.14.717 1.915.717s1.43-.34 1.915-.717a4.4 4.4 0 0 0 .721-.714l.005-.007-.001.002.61.436.61.436-.001.002-.002.003-.006.007-.016.023-.056.071q-.07.091-.2.235c-.17.189-.42.439-.744.69-.64.497-1.61 1.033-2.835 1.033s-2.196-.536-2.835-1.033a6 6 0 0 1-.944-.925l-.056-.071-.016-.023-.006-.007-.002-.003v-.001s-.001-.001.609-.437l.61-.436-.001-.002.005.007.03.04q.045.056.139.161c.126.14.313.327.552.513" clip-rule="evenodd"/>`
    }, props));
$6b94a631f0b72fed$var$EmojiIcon.displayName = 'EmojiIcon';
var $6b94a631f0b72fed$var$_default = module.exports.default = $6b94a631f0b72fed$var$EmojiIcon;

});

parcelRegister("1kVeP", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b2b6456aaf4426c97739f87704196a6f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0f940f03e44f9ec9$var$_react = $0f940f03e44f9ec9$var$_interopRequireDefault((parcelRequire("42omo")));

var $0f940f03e44f9ec9$var$_baseNew = $0f940f03e44f9ec9$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $0f940f03e44f9ec9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "GrowHorizontal".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for increasing the width of an element.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0f940f03e44f9ec9$var$GrowHorizontalIcon = (props)=>/*#__PURE__*/ $0f940f03e44f9ec9$var$_react.default.createElement($0f940f03e44f9ec9$var$_baseNew.default, Object.assign({
        name: "GrowHorizontalIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m.22 7.47 3.5-3.5 1.06 1.06-2.22 2.22H7v1.5H2.56l2.22 2.22-1.06 1.06-3.5-3.5a.75.75 0 0 1 0-1.06m13.22-.22-2.22-2.22 1.06-1.06 3.5 3.5a.75.75 0 0 1 0 1.06l-3.5 3.5-1.06-1.06 2.22-2.22H9v-1.5z" clip-rule="evenodd"/>`
    }, props));
$0f940f03e44f9ec9$var$GrowHorizontalIcon.displayName = 'GrowHorizontalIcon';
var $0f940f03e44f9ec9$var$_default = module.exports.default = $0f940f03e44f9ec9$var$GrowHorizontalIcon;

});

parcelRegister("f22ZH", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4cc30cca446ee2bc7bd4f679561c5adc>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $af195d81409eacaa$var$_react = $af195d81409eacaa$var$_interopRequireDefault((parcelRequire("42omo")));

var $af195d81409eacaa$var$_baseNew = $af195d81409eacaa$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $af195d81409eacaa$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "LayoutThreeColumns".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for 3 column layout option in Confluence Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $af195d81409eacaa$var$LayoutThreeColumnsIcon = (props)=>/*#__PURE__*/ $af195d81409eacaa$var$_react.default.createElement($af195d81409eacaa$var$_baseNew.default, Object.assign({
        name: "LayoutThreeColumnsIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 2.375C0 1.615.616 1 1.375 1h1.5c.76 0 1.375.616 1.375 1.375v11.25c0 .76-.616 1.375-1.375 1.375h-1.5C.615 15 0 14.384 0 13.625zm1.5.125v11h1.25v-11zm4.25-.125C5.75 1.615 6.366 1 7.125 1h1.75c.76 0 1.375.616 1.375 1.375v11.25c0 .76-.616 1.375-1.375 1.375h-1.75c-.76 0-1.375-.616-1.375-1.375zm1.5.125v11h1.5v-11zm4.5-.125c0-.76.616-1.375 1.375-1.375h1.5C15.385 1 16 1.616 16 2.375v11.25c0 .76-.616 1.375-1.375 1.375h-1.5c-.76 0-1.375-.616-1.375-1.375zm1.5.125v11h1.25v-11z" clip-rule="evenodd"/>`
    }, props));
$af195d81409eacaa$var$LayoutThreeColumnsIcon.displayName = 'LayoutThreeColumnsIcon';
var $af195d81409eacaa$var$_default = module.exports.default = $af195d81409eacaa$var$LayoutThreeColumnsIcon;

});

parcelRegister("5NtbR", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::314560a3eae62141d1d45d3625a6de50>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $43882beaa73d1088$var$_react = $43882beaa73d1088$var$_interopRequireDefault((parcelRequire("42omo")));

var $43882beaa73d1088$var$_baseNew = $43882beaa73d1088$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $43882beaa73d1088$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "LayoutThreeColumnsSidebars".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for 3 column layout with left and right sidebars option in Confluence Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $43882beaa73d1088$var$LayoutThreeColumnsSidebarsIcon = (props)=>/*#__PURE__*/ $43882beaa73d1088$var$_react.default.createElement($43882beaa73d1088$var$_baseNew.default, Object.assign({
        name: "LayoutThreeColumnsSidebarsIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 2.375C0 1.615.616 1 1.375 1h.75c.76 0 1.375.616 1.375 1.375v11.25c0 .76-.616 1.375-1.375 1.375h-.75C.615 15 0 14.384 0 13.625zm1.5.125v11H2v-11zM5 2.375C5 1.615 5.616 1 6.375 1h3.25C10.385 1 11 1.616 11 2.375v11.25c0 .76-.616 1.375-1.375 1.375h-3.25C5.615 15 5 14.384 5 13.625zm1.5.125v11h3v-11zm6-.125c0-.76.616-1.375 1.375-1.375h.75C15.385 1 16 1.616 16 2.375v11.25c0 .76-.616 1.375-1.375 1.375h-.75c-.76 0-1.375-.616-1.375-1.375zM14 2.5v11h.5v-11z" clip-rule="evenodd"/>`
    }, props));
$43882beaa73d1088$var$LayoutThreeColumnsSidebarsIcon.displayName = 'LayoutThreeColumnsSidebarsIcon';
var $43882beaa73d1088$var$_default = module.exports.default = $43882beaa73d1088$var$LayoutThreeColumnsSidebarsIcon;

});

parcelRegister("3uQ0E", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::becdeda8f8450c41ab5988200094862a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $28bc846ec4643487$var$_react = $28bc846ec4643487$var$_interopRequireDefault((parcelRequire("42omo")));

var $28bc846ec4643487$var$_baseNew = $28bc846ec4643487$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $28bc846ec4643487$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ContentWidthNarrow".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for setting media and content to a narrow width.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $28bc846ec4643487$var$ContentWidthNarrowIcon = (props)=>/*#__PURE__*/ $28bc846ec4643487$var$_react.default.createElement($28bc846ec4643487$var$_baseNew.default, Object.assign({
        name: "ContentWidthNarrowIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M14 2.5H2V1h12zm-10.5 3v5h9v-5zM3.375 4h9.25C13.385 4 14 4.616 14 5.375v5.25c0 .76-.616 1.375-1.375 1.375h-9.25C2.615 12 2 11.384 2 10.625v-5.25C2 4.615 2.616 4 3.375 4M14 15H2v-1.5h12z" clip-rule="evenodd"/>`
    }, props));
$28bc846ec4643487$var$ContentWidthNarrowIcon.displayName = 'ContentWidthNarrowIcon';
var $28bc846ec4643487$var$_default = module.exports.default = $28bc846ec4643487$var$ContentWidthNarrowIcon;

});

parcelRegister("gzsfl", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5756fa661fb64df215b386b689bcf117>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c105d36702cd9305$var$_react = $c105d36702cd9305$var$_interopRequireDefault((parcelRequire("42omo")));

var $c105d36702cd9305$var$_baseNew = $c105d36702cd9305$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $c105d36702cd9305$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ExpandHorizontal".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for expanding an element to its maximum width.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c105d36702cd9305$var$ExpandHorizontalIcon = (props)=>/*#__PURE__*/ $c105d36702cd9305$var$_react.default.createElement($c105d36702cd9305$var$_baseNew.default, Object.assign({
        name: "ExpandHorizontalIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M1.5 1v14H0V1zM16 1v14h-1.5V1zm-1.72 6.47a.75.75 0 0 1 0 1.06l-3.25 3.25-1.06-1.06 1.97-1.97H4.06l1.97 1.97-1.06 1.06-3.25-3.25a.75.75 0 0 1 0-1.06l3.25-3.25 1.06 1.06-1.97 1.97h7.88L9.97 5.28l1.06-1.06z"/>`
    }, props));
$c105d36702cd9305$var$ExpandHorizontalIcon.displayName = 'ExpandHorizontalIcon';
var $c105d36702cd9305$var$_default = module.exports.default = $c105d36702cd9305$var$ExpandHorizontalIcon;

});

parcelRegister("kDG8M", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5a65ef02b42df957b8012c4998bb403f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f0682367c41faa8d$var$_react = $f0682367c41faa8d$var$_interopRequireDefault((parcelRequire("42omo")));

var $f0682367c41faa8d$var$_baseNew = $f0682367c41faa8d$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $f0682367c41faa8d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ContentWidthWide".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for setting media and content to a wide width.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f0682367c41faa8d$var$ContentWidthWideIcon = (props)=>/*#__PURE__*/ $f0682367c41faa8d$var$_react.default.createElement($f0682367c41faa8d$var$_baseNew.default, Object.assign({
        name: "ContentWidthWideIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M12 2.5H4V1h8zm-10.5 3v5h13v-5zM1.375 4h13.25C15.385 4 16 4.616 16 5.375v5.25c0 .76-.616 1.375-1.375 1.375H1.375C.615 12 0 11.384 0 10.625v-5.25C0 4.615.616 4 1.375 4M12 15H4v-1.5h8z" clip-rule="evenodd"/>`
    }, props));
$f0682367c41faa8d$var$ContentWidthWideIcon.displayName = 'ContentWidthWideIcon';
var $f0682367c41faa8d$var$_default = module.exports.default = $f0682367c41faa8d$var$ContentWidthWideIcon;

});

parcelRegister("9Ctkw", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c2494db76a67b997170fcc19554c20c8>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $700e69f9abed7b88$var$_react = $700e69f9abed7b88$var$_interopRequireDefault((parcelRequire("42omo")));

var $700e69f9abed7b88$var$_baseNew = $700e69f9abed7b88$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $700e69f9abed7b88$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ContentWrapLeft".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for left aligning media and content with wrapping enabled.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $700e69f9abed7b88$var$ContentWrapLeftIcon = (props)=>/*#__PURE__*/ $700e69f9abed7b88$var$_react.default.createElement($700e69f9abed7b88$var$_baseNew.default, Object.assign({
        name: "ContentWrapLeftIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M15 2.5H1V1h14zm-12.5 4v3h3v-3zM2.375 5h3.25C6.385 5 7 5.616 7 6.375v3.25C7 10.385 6.384 11 5.625 11h-3.25C1.615 11 1 10.384 1 9.625v-3.25C1 5.615 1.616 5 2.375 5M15 6.667H9v-1.5h6zm0 4.166H9v-1.5h6zM15 15H1v-1.5h14z" clip-rule="evenodd"/>`
    }, props));
$700e69f9abed7b88$var$ContentWrapLeftIcon.displayName = 'ContentWrapLeftIcon';
var $700e69f9abed7b88$var$_default = module.exports.default = $700e69f9abed7b88$var$ContentWrapLeftIcon;

});

parcelRegister("2y4tz", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1f7654718483868ec656fda28b5f1426>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1db23a990eaaba71$var$_react = $1db23a990eaaba71$var$_interopRequireDefault((parcelRequire("42omo")));

var $1db23a990eaaba71$var$_baseNew = $1db23a990eaaba71$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $1db23a990eaaba71$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ListNumbered".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known usages: Numbered list in Confluence Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $1db23a990eaaba71$var$ListNumberedIcon = (props)=>/*#__PURE__*/ $1db23a990eaaba71$var$_react.default.createElement($1db23a990eaaba71$var$_baseNew.default, Object.assign({
        name: "ListNumberedIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M16 5H6V3.5h10zm0 7.5H6V11h10zM.5 1h1.75a.75.75 0 0 1 .75.75V7H1.5V2.5h-1zM0 8.5h2.63C3.39 8.5 4 9.12 4 9.88v1.25c0 .76-.62 1.38-1.37 1.38H1.5v1H4V15H.75a.75.75 0 0 1-.75-.75v-1.87C0 11.62.62 11 1.38 11H2.5v-1H0z" clip-rule="evenodd"/>`
    }, props));
$1db23a990eaaba71$var$ListNumberedIcon.displayName = 'ListNumberedIcon';
var $1db23a990eaaba71$var$_default = module.exports.default = $1db23a990eaaba71$var$ListNumberedIcon;

});

parcelRegister("dRLbl", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ea2f9ccde642b201921aa68be6179ead>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a184d2fa6e3dcc79$var$_react = $a184d2fa6e3dcc79$var$_interopRequireDefault((parcelRequire("42omo")));

var $a184d2fa6e3dcc79$var$_baseNew = $a184d2fa6e3dcc79$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $a184d2fa6e3dcc79$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TextIndentLeft".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for shifting the indent of text content left.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a184d2fa6e3dcc79$var$TextIndentLeftIcon = (props)=>/*#__PURE__*/ $a184d2fa6e3dcc79$var$_react.default.createElement($a184d2fa6e3dcc79$var$_baseNew.default, Object.assign({
        name: "TextIndentLeftIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M15 2.5H1V1h14zM2.81 8l2.22-2.22-1.06-1.06-2.75 2.75a.75.75 0 0 0 0 1.06l2.75 2.75 1.06-1.06zM15 6.667H8v-1.5h7zm0 4.166H8v-1.5h7zM15 15H1v-1.5h14z" clip-rule="evenodd"/>`
    }, props));
$a184d2fa6e3dcc79$var$TextIndentLeftIcon.displayName = 'TextIndentLeftIcon';
var $a184d2fa6e3dcc79$var$_default = module.exports.default = $a184d2fa6e3dcc79$var$TextIndentLeftIcon;

});

parcelRegister("kFjZK", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::212245c1584bec684ced80344b70bcc4>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f0b7258cd45dc8d2$var$_react = $f0b7258cd45dc8d2$var$_interopRequireDefault((parcelRequire("42omo")));

var $f0b7258cd45dc8d2$var$_baseNew = $f0b7258cd45dc8d2$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $f0b7258cd45dc8d2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Redo".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for redo in Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f0b7258cd45dc8d2$var$RedoIcon = (props)=>/*#__PURE__*/ $f0b7258cd45dc8d2$var$_react.default.createElement($f0b7258cd45dc8d2$var$_baseNew.default, Object.assign({
        name: "RedoIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m14.78 4.72-3.5-3.5-1.06 1.06 2.22 2.22H5.75a4.75 4.75 0 0 0 0 9.5H8v-1.5H5.75a3.25 3.25 0 0 1 0-6.5h6.69l-2.22 2.22 1.06 1.06 3.5-3.5a.75.75 0 0 0 0-1.06" clip-rule="evenodd"/>`
    }, props));
$f0b7258cd45dc8d2$var$RedoIcon.displayName = 'RedoIcon';
var $f0b7258cd45dc8d2$var$_default = module.exports.default = $f0b7258cd45dc8d2$var$RedoIcon;

});

parcelRegister("gKvd9", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4f8e09626672d9215bf80d7cf3a8d93a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c3192713330dc291$var$_react = $c3192713330dc291$var$_interopRequireDefault((parcelRequire("42omo")));

var $c3192713330dc291$var$_baseNew = $c3192713330dc291$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $c3192713330dc291$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Delete".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for removing or deleting an object.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c3192713330dc291$var$DeleteIcon = (props)=>/*#__PURE__*/ $c3192713330dc291$var$_react.default.createElement($c3192713330dc291$var$_baseNew.default, Object.assign({
        name: "DeleteIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M5 .75A.75.75 0 0 1 5.75 0h4.5a.75.75 0 0 1 .75.75V2.5h3.5V4h-1v10a2 2 0 0 1-2 2h-7a2 2 0 0 1-2-2V4h-1V2.5H5zM6.5 2.5h3v-1h-3zM4 4v10a.5.5 0 0 0 .5.5h7a.5.5 0 0 0 .5-.5V4zm1.75 9V5.5h1.5V13zm3 0V5.5h1.5V13z" clip-rule="evenodd"/>`
    }, props));
$c3192713330dc291$var$DeleteIcon.displayName = 'DeleteIcon';
var $c3192713330dc291$var$_default = module.exports.default = $c3192713330dc291$var$DeleteIcon;

});

parcelRegister("5gydP", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9f0917f4199f5ead8e2ff316703c32c4>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3d58fe253466b571$var$_react = $3d58fe253466b571$var$_interopRequireDefault((parcelRequire("42omo")));

var $3d58fe253466b571$var$_baseNew = $3d58fe253466b571$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $3d58fe253466b571$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TextStyle".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for text styles in Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3d58fe253466b571$var$TextStyleIcon = (props)=>/*#__PURE__*/ $3d58fe253466b571$var$_react.default.createElement($3d58fe253466b571$var$_baseNew.default, Object.assign({
        name: "TextStyleIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.799.484A.75.75 0 0 1 7.5 0h1.018a.75.75 0 0 1 .701.485l3.733 9.875a.8.8 0 0 1 .048.265V11h-1.5v-.238L10.456 8H5.55L4.5 10.763V11H3v-.375a.8.8 0 0 1 .049-.266zM6.119 6.5h3.77L8.01 1.524z" clip-rule="evenodd"/>`
    }, props));
$3d58fe253466b571$var$TextStyleIcon.displayName = 'TextStyleIcon';
var $3d58fe253466b571$var$_default = module.exports.default = $3d58fe253466b571$var$TextStyleIcon;

});

parcelRegister("hw7wB", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::afc4f0315b11d9afea68ddf0758e998e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $cc0b431723a27b6e$var$_react = $cc0b431723a27b6e$var$_interopRequireDefault((parcelRequire("42omo")));

var $cc0b431723a27b6e$var$_baseNew = $cc0b431723a27b6e$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $cc0b431723a27b6e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Upload".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for upload in Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $cc0b431723a27b6e$var$UploadIcon = (props)=>/*#__PURE__*/ $cc0b431723a27b6e$var$_react.default.createElement($cc0b431723a27b6e$var$_baseNew.default, Object.assign({
        name: "UploadIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M7.47 1.22a.75.75 0 0 1 1.06 0l4 4-1.06 1.06-2.72-2.72V11h-1.5V3.56L4.53 6.28 3.47 5.22zM1 13V9h1.5v4a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V9H15v4a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2" clip-rule="evenodd"/>`
    }, props));
$cc0b431723a27b6e$var$UploadIcon.displayName = 'UploadIcon';
var $cc0b431723a27b6e$var$_default = module.exports.default = $cc0b431723a27b6e$var$UploadIcon;

});

parcelRegister("lOzEN", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::98db7ecf7a88004ad911d912e316fd5e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fe19ed37e94ed81a$var$_react = $fe19ed37e94ed81a$var$_interopRequireDefault((parcelRequire("42omo")));

var $fe19ed37e94ed81a$var$_baseNew = $fe19ed37e94ed81a$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $fe19ed37e94ed81a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "GrowDiagonal".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for increasing the size of an element when height and width are changed concurrently.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $fe19ed37e94ed81a$var$GrowDiagonalIcon = (props)=>/*#__PURE__*/ $fe19ed37e94ed81a$var$_react.default.createElement($fe19ed37e94ed81a$var$_baseNew.default, Object.assign({
        name: "GrowDiagonalIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M14.78 2.28 9.53 7.53 8.47 6.47l5.25-5.25zM1.22 13.72l5.25-5.25 1.06 1.06-5.25 5.25z" clip-rule="evenodd"/><path fill="currentcolor" fill-rule="evenodd" d="M9.5 1h4.75a.75.75 0 0 1 .75.75V6.5h-1.5v-4h-4zm-7 12.5v-4H1v4.75c0 .414.336.75.75.75H6.5v-1.5z" clip-rule="evenodd"/>`
    }, props));
$fe19ed37e94ed81a$var$GrowDiagonalIcon.displayName = 'GrowDiagonalIcon';
var $fe19ed37e94ed81a$var$_default = module.exports.default = $fe19ed37e94ed81a$var$GrowDiagonalIcon;

});

parcelRegister("4wwVl", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e5a2b32fe863ac429d199dc8b174e3b3>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $34b3b09757562b8e$var$_react = $34b3b09757562b8e$var$_interopRequireDefault((parcelRequire("42omo")));

var $34b3b09757562b8e$var$_baseNew = $34b3b09757562b8e$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $34b3b09757562b8e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PersonAvatar".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for user avatar.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $34b3b09757562b8e$var$PersonAvatarIcon = (props)=>/*#__PURE__*/ $34b3b09757562b8e$var$_react.default.createElement($34b3b09757562b8e$var$_baseNew.default, Object.assign({
        name: "PersonAvatarIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a6.5 6.5 0 0 0-4.148 11.505A2.75 2.75 0 0 1 6.5 11h3c1.26 0 2.323.848 2.648 2.005A6.5 6.5 0 0 0 8 1.5m2.75 12.392v-.142c0-.69-.56-1.25-1.25-1.25h-3c-.69 0-1.25.56-1.25 1.25v.142l.06.027c.82.373 1.73.581 2.69.581s1.87-.208 2.69-.58q.03-.016.06-.028M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m8-3.5a2 2 0 1 0 0 4 2 2 0 0 0 0-4m-3.5 2a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0" clip-rule="evenodd"/>`
    }, props));
$34b3b09757562b8e$var$PersonAvatarIcon.displayName = 'PersonAvatarIcon';
var $34b3b09757562b8e$var$_default = module.exports.default = $34b3b09757562b8e$var$PersonAvatarIcon;

});

parcelRegister("8tdj3", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6b603e49d606132e091f78e8fc1c638c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $62ab5a81461bade1$var$_react = $62ab5a81461bade1$var$_interopRequireDefault((parcelRequire("42omo")));

var $62ab5a81461bade1$var$_baseNew = $62ab5a81461bade1$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $62ab5a81461bade1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "LinkExternal".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for links that open up a new tab.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $62ab5a81461bade1$var$LinkExternalIcon = (props)=>/*#__PURE__*/ $62ab5a81461bade1$var$_react.default.createElement($62ab5a81461bade1$var$_baseNew.default, Object.assign({
        name: "LinkExternalIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M3 2.5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5v-3H15v3a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h3v1.5zM10 1h4.25a.75.75 0 0 1 .75.75V6h-1.5V3.56L7.53 9.53 6.47 8.47l5.97-5.97H10z" clip-rule="evenodd"/>`
    }, props));
$62ab5a81461bade1$var$LinkExternalIcon.displayName = 'LinkExternalIcon';
var $62ab5a81461bade1$var$_default = module.exports.default = $62ab5a81461bade1$var$LinkExternalIcon;

});

parcelRegister("h1ewt", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5c5d989acf678b87189f6f5a97917ee9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c63dcb99536cc850$var$_react = $c63dcb99536cc850$var$_interopRequireDefault((parcelRequire("42omo")));

var $c63dcb99536cc850$var$_baseNew = $c63dcb99536cc850$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $c63dcb99536cc850$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "LockUnlocked".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: unlocked page in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c63dcb99536cc850$var$LockUnlockedIcon = (props)=>/*#__PURE__*/ $c63dcb99536cc850$var$_react.default.createElement($c63dcb99536cc850$var$_baseNew.default, Object.assign({
        name: "LockUnlockedIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5A2.5 2.5 0 0 0 5.5 4v3H12a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2V4a4 4 0 1 1 8 0h-1.5A2.5 2.5 0 0 0 8 1.5m-4 7a.5.5 0 0 0-.5.5v5a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5V9a.5.5 0 0 0-.5-.5z" clip-rule="evenodd"/>`
    }, props));
$c63dcb99536cc850$var$LockUnlockedIcon.displayName = 'LockUnlockedIcon';
var $c63dcb99536cc850$var$_default = module.exports.default = $c63dcb99536cc850$var$LockUnlockedIcon;

});

parcelRegister("bAxHS", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b4e115bf1196067744edbc137a8f667f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $86fd33f7b3df1ba6$var$_react = $86fd33f7b3df1ba6$var$_interopRequireDefault((parcelRequire("42omo")));

var $86fd33f7b3df1ba6$var$_baseNew = $86fd33f7b3df1ba6$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $86fd33f7b3df1ba6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Microphone".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: record sounds in Trello.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $86fd33f7b3df1ba6$var$MicrophoneIcon = (props)=>/*#__PURE__*/ $86fd33f7b3df1ba6$var$_react.default.createElement($86fd33f7b3df1ba6$var$_baseNew.default, Object.assign({
        name: "MicrophoneIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5A1.5 1.5 0 0 0 6.5 3v4a1.5 1.5 0 1 0 3 0V3A1.5 1.5 0 0 0 8 1.5M5 3a3 3 0 0 1 6 0v4a3 3 0 0 1-6 0zM3.5 7a4.5 4.5 0 0 0 9 0H14c0 3.06-2.29 5.585-5.25 5.954V14.5H12V16H4v-1.5h3.25v-1.546A6 6 0 0 1 2 7z" clip-rule="evenodd"/>`
    }, props));
$86fd33f7b3df1ba6$var$MicrophoneIcon.displayName = 'MicrophoneIcon';
var $86fd33f7b3df1ba6$var$_default = module.exports.default = $86fd33f7b3df1ba6$var$MicrophoneIcon;

});

parcelRegister("avrhI", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::bc3145262927e8aafd6e7a23c5905db2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7a61f6ca9f1fa7cb$var$_react = $7a61f6ca9f1fa7cb$var$_interopRequireDefault((parcelRequire("42omo")));

var $7a61f6ca9f1fa7cb$var$_baseNew = $7a61f6ca9f1fa7cb$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $7a61f6ca9f1fa7cb$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "FullscreenEnter".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for full screen videos or objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7a61f6ca9f1fa7cb$var$FullscreenEnterIcon = (props)=>/*#__PURE__*/ $7a61f6ca9f1fa7cb$var$_react.default.createElement($7a61f6ca9f1fa7cb$var$_baseNew.default, Object.assign({
        name: "FullscreenEnterIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M13 2.5h-3V1h3a2 2 0 0 1 2 2v3h-1.5V3a.5.5 0 0 0-.5-.5m-10 0a.5.5 0 0 0-.5.5v3H1V3a2 2 0 0 1 2-2h3v1.5zM2.5 10v3a.5.5 0 0 0 .5.5h3V15H3a2 2 0 0 1-2-2v-3zm11 3v-3H15v3a2 2 0 0 1-2 2h-3v-1.5h3a.5.5 0 0 0 .5-.5" clip-rule="evenodd"/>`
    }, props));
$7a61f6ca9f1fa7cb$var$FullscreenEnterIcon.displayName = 'FullscreenEnterIcon';
var $7a61f6ca9f1fa7cb$var$_default = module.exports.default = $7a61f6ca9f1fa7cb$var$FullscreenEnterIcon;

});

parcelRegister("9aGns", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::856226f5e73dfc11c44d43d912e311e0>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6ad5eb77a9d7cb1f$var$_react = $6ad5eb77a9d7cb1f$var$_interopRequireDefault((parcelRequire("42omo")));

var $6ad5eb77a9d7cb1f$var$_baseNew = $6ad5eb77a9d7cb1f$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $6ad5eb77a9d7cb1f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Download".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for file downloads.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6ad5eb77a9d7cb1f$var$DownloadIcon = (props)=>/*#__PURE__*/ $6ad5eb77a9d7cb1f$var$_react.default.createElement($6ad5eb77a9d7cb1f$var$_baseNew.default, Object.assign({
        name: "DownloadIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.75 1v7.44l2.72-2.72 1.06 1.06-4 4a.75.75 0 0 1-1.06 0l-4-4 1.06-1.06 2.72 2.72V1zM1 13V9h1.5v4a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V9H15v4a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2" clip-rule="evenodd"/>`
    }, props));
$6ad5eb77a9d7cb1f$var$DownloadIcon.displayName = 'DownloadIcon';
var $6ad5eb77a9d7cb1f$var$_default = module.exports.default = $6ad5eb77a9d7cb1f$var$DownloadIcon;

});

parcelRegister("4FHTF", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::cf6065af0d56e84610020204bbc954cd>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $366d0ac32486011a$var$_react = $366d0ac32486011a$var$_interopRequireDefault((parcelRequire("42omo")));

var $366d0ac32486011a$var$_baseNew = $366d0ac32486011a$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $366d0ac32486011a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "EmojiAdd".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for adding an emoji reaction.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $366d0ac32486011a$var$EmojiAddIcon = (props)=>/*#__PURE__*/ $366d0ac32486011a$var$_react.default.createElement($366d0ac32486011a$var$_baseNew.default, Object.assign({
        name: "EmojiAddIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1.5 8a6.5 6.5 0 1 0 13 0H16a8 8 0 1 1-8-8v1.5A6.5 6.5 0 0 0 1.5 8m4.585 2.033c.486.378 1.14.717 1.915.717s1.43-.34 1.915-.717a4.4 4.4 0 0 0 .721-.714l.005-.007-.001.002.61.436.61.436-.001.002-.002.003-.006.007-.016.023-.056.071q-.07.091-.2.235c-.17.189-.42.439-.744.69-.64.497-1.61 1.033-2.835 1.033s-2.196-.536-2.835-1.033a6 6 0 0 1-.944-.925l-.056-.071-.016-.023-.006-.007-.002-.003v-.001s-.001-.001.609-.437l.61-.436-.001-.002.005.007.03.04q.045.056.139.161c.126.14.313.327.552.513M5.75 7.5a1.25 1.25 0 1 1 0-2.5 1.25 1.25 0 0 1 0 2.5m4.5 0a1.25 1.25 0 1 1 0-2.5 1.25 1.25 0 0 1 0 2.5m2.25-4h-2V2h2V0H14v2h2v1.5h-2v2h-1.5z" clip-rule="evenodd"/>`
    }, props));
$366d0ac32486011a$var$EmojiAddIcon.displayName = 'EmojiAddIcon';
var $366d0ac32486011a$var$_default = module.exports.default = $366d0ac32486011a$var$EmojiAddIcon;

});

parcelRegister("4BqOc", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c248cb8ff46f92a14313d2de4318df80>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $359f69ca2b6289ab$var$_react = $359f69ca2b6289ab$var$_interopRequireDefault((parcelRequire("42omo")));

var $359f69ca2b6289ab$var$_baseNew = $359f69ca2b6289ab$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $359f69ca2b6289ab$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Changes".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for changes in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $359f69ca2b6289ab$var$ChangesIcon = (props)=>/*#__PURE__*/ $359f69ca2b6289ab$var$_react.default.createElement($359f69ca2b6289ab$var$_baseNew.default, Object.assign({
        name: "ChangesIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M14.78 4.22 11.53.97l-1.06 1.06L12.44 4H2v1.5h10.44l-1.97 1.97 1.06 1.06 3.25-3.25a.75.75 0 0 0 0-1.06M3.56 10.5l1.97-1.97-1.06-1.06-3.25 3.25a.75.75 0 0 0 0 1.06l3.25 3.25 1.06-1.06L3.56 12H14v-1.5z" clip-rule="evenodd"/>`
    }, props));
$359f69ca2b6289ab$var$ChangesIcon.displayName = 'ChangesIcon';
var $359f69ca2b6289ab$var$_default = module.exports.default = $359f69ca2b6289ab$var$ChangesIcon;

});

parcelRegister("j398X", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3c3d7920d21840bbdbda77777279aae7>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $dde563d5581cd693$var$_react = $dde563d5581cd693$var$_interopRequireDefault((parcelRequire("42omo")));

var $dde563d5581cd693$var$_baseNew = $dde563d5581cd693$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $dde563d5581cd693$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "EmojiCasual".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for representing a casual or relaxed tone or sentiment.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $dde563d5581cd693$var$EmojiCasualIcon = (props)=>/*#__PURE__*/ $dde563d5581cd693$var$_react.default.createElement($dde563d5581cd693$var$_baseNew.default, Object.assign({
        name: "EmojiCasualIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m1.776 6.119.279 1.3A2 2 0 0 0 4.01 9h1.054a2.625 2.625 0 0 0 2.61-2.345L7.8 5.5h.4l.124 1.155A2.625 2.625 0 0 0 10.935 9h1.054a2 2 0 0 0 1.956-1.58l.279-1.301a6.5 6.5 0 1 1-12.448 0M13.124 4A6.49 6.49 0 0 0 8 1.5c-2.08 0-3.934.977-5.124 2.5zm-.302 1.5H9.71l.106.995A1.125 1.125 0 0 0 10.935 7.5h1.054a.5.5 0 0 0 .49-.395zm-6.532 0H3.178l.344 1.605a.5.5 0 0 0 .489.395h1.054c.575 0 1.058-.433 1.119-1.005zM.847 4.413A8 8 0 0 1 8 0a8 8 0 1 1 0 16A8 8 0 0 1 .847 4.413m5.238 6.12c.486.378 1.14.717 1.915.717s1.43-.34 1.915-.717a4.4 4.4 0 0 0 .69-.675l.031-.04.005-.006-.001.002.61.436.61.436-.001.002-.002.003-.006.007-.016.023-.056.071q-.07.091-.2.235c-.17.189-.42.439-.744.69-.64.497-1.61 1.033-2.835 1.033s-2.196-.536-2.835-1.033a6 6 0 0 1-.944-.925l-.056-.071-.016-.023-.006-.007-.002-.003v-.001s-.001-.001.609-.437l.61-.436-.001-.002.005.007.03.04q.045.056.139.161c.126.14.313.327.552.513m4.556-.721" clip-rule="evenodd"/>`
    }, props));
$dde563d5581cd693$var$EmojiCasualIcon.displayName = 'EmojiCasualIcon';
var $dde563d5581cd693$var$_default = module.exports.default = $dde563d5581cd693$var$EmojiCasualIcon;

});

parcelRegister("kMl1Y", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a2ac947f63209d241272a5f59270c101>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f2089aa57b5b8b7d$var$_react = $f2089aa57b5b8b7d$var$_interopRequireDefault((parcelRequire("42omo")));

var $f2089aa57b5b8b7d$var$_baseNew = $f2089aa57b5b8b7d$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $f2089aa57b5b8b7d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "EmojiNeutral".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for representing a neutral tone or sentiment.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f2089aa57b5b8b7d$var$EmojiNeutralIcon = (props)=>/*#__PURE__*/ $f2089aa57b5b8b7d$var$_react.default.createElement($f2089aa57b5b8b7d$var$_baseNew.default, Object.assign({
        name: "EmojiNeutralIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m4.5-1.75a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0m4.5 0a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0m2.25 3.25V11h-6.5V9.5z" clip-rule="evenodd"/>`
    }, props));
$f2089aa57b5b8b7d$var$EmojiNeutralIcon.displayName = 'EmojiNeutralIcon';
var $f2089aa57b5b8b7d$var$_default = module.exports.default = $f2089aa57b5b8b7d$var$EmojiNeutralIcon;

});

parcelRegister("2G5zx", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3fcc7ec4e4a90ef6f278af13d73450d0>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1f33d38551414dee$var$_react = $1f33d38551414dee$var$_interopRequireDefault((parcelRequire("42omo")));

var $1f33d38551414dee$var$_baseNew = $1f33d38551414dee$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $1f33d38551414dee$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "EmojiRemove".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for removing emoji.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $1f33d38551414dee$var$EmojiRemoveIcon = (props)=>/*#__PURE__*/ $1f33d38551414dee$var$_react.default.createElement($1f33d38551414dee$var$_baseNew.default, Object.assign({
        name: "EmojiRemoveIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m10.72 13.9 1.12 1.12A8 8 0 0 1 .98 4.16L2.1 5.28a6.5 6.5 0 0 0 8.63 8.63M8 0C6.61 0 5.3.36 4.16.98L5.28 2.1a6.5 6.5 0 0 1 8.63 8.63l1.12 1.12A8 8 0 0 0 8 0"/><path fill="currentcolor" d="m9.06 5.88 1.57 1.57a1.25 1.25 0 1 0-1.57-1.57m-2.97 4.15c.38.3.87.57 1.44.67l1.43 1.43c-.3.07-.62.11-.96.11-1.23 0-2.2-.54-2.83-1.03a6 6 0 0 1-.94-.92l-.06-.07-.02-.02-.01-.01.61-.44.61-.44.01.01.03.04q.05.06.14.16c.13.14.31.33.55.51M.47 1.53l14 14 1.06-1.06-14-14z"/>`
    }, props));
$1f33d38551414dee$var$EmojiRemoveIcon.displayName = 'EmojiRemoveIcon';
var $1f33d38551414dee$var$_default = module.exports.default = $1f33d38551414dee$var$EmojiRemoveIcon;

});

parcelRegister("4SWbm", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::27415f759dcf84731b49eedf76030531>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $38e956594bc2295e$var$_react = $38e956594bc2295e$var$_interopRequireDefault((parcelRequire("42omo")));

var $38e956594bc2295e$var$_baseNew = $38e956594bc2295e$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $38e956594bc2295e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Epic".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for epics in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $38e956594bc2295e$var$EpicIcon = (props)=>/*#__PURE__*/ $38e956594bc2295e$var$_react.default.createElement($38e956594bc2295e$var$_baseNew.default, Object.assign({
        name: "EpicIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M10.271.05a.75.75 0 0 1 .479.7v4.635l3.147.63a.75.75 0 0 1 .407 1.24l-7.75 8.5a.75.75 0 0 1-1.304-.505v-4.635l-3.147-.63a.75.75 0 0 1-.407-1.24l7.75-8.5A.75.75 0 0 1 10.27.05M3.698 8.776l3.052.61v3.93l5.552-6.09-3.052-.61v-3.93z" clip-rule="evenodd"/>`
    }, props));
$38e956594bc2295e$var$EpicIcon.displayName = 'EpicIcon';
var $38e956594bc2295e$var$_default = module.exports.default = $38e956594bc2295e$var$EpicIcon;

});

parcelRegister("aRCWA", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fc35d7011127658ef0b5408810ae194b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7e8d10150b03f07c$var$_react = $7e8d10150b03f07c$var$_interopRequireDefault((parcelRequire("42omo")));

var $7e8d10150b03f07c$var$_baseNew = $7e8d10150b03f07c$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $7e8d10150b03f07c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "EyeOpenStrikethrough".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Intended uses: unwatch page in Confluence, hide password in text field, and unfollow in Atlas.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7e8d10150b03f07c$var$EyeOpenStrikethroughIcon = (props)=>/*#__PURE__*/ $7e8d10150b03f07c$var$_react.default.createElement($7e8d10150b03f07c$var$_baseNew.default, Object.assign({
        name: "EyeOpenStrikethroughIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m.47 1.53 14 14 1.06-1.06-14-14zm8.74 10.86 1.24 1.24A8.5 8.5 0 0 1 8 14C4.43 14 1.32 11.77.17 8.62c-.15-.4-.15-.84 0-1.24a8 8 0 0 1 1.51-2.53l1.06 1.06a6.5 6.5 0 0 0-1.16 1.98.3.3 0 0 0 0 .21c.93 2.56 3.48 4.4 6.42 4.4q.62 0 1.21-.11M8 2a8.5 8.5 0 0 0-2.45.36L6.79 3.6q.59-.1 1.21-.1c2.94 0 5.49 1.85 6.42 4.4a.3.3 0 0 1 0 .21 6.5 6.5 0 0 1-1.16 1.98l1.06 1.06a8 8 0 0 0 1.51-2.53c.15-.4.15-.84 0-1.24C14.68 4.23 11.57 2 8 2"/>`
    }, props));
$7e8d10150b03f07c$var$EyeOpenStrikethroughIcon.displayName = 'EyeOpenStrikethroughIcon';
var $7e8d10150b03f07c$var$_default = module.exports.default = $7e8d10150b03f07c$var$EyeOpenStrikethroughIcon;

});

parcelRegister("eG1e2", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b6405c70debcc4f4b2a8d477842ac4ae>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $aaf5f0417c8d4f4a$var$_react = $aaf5f0417c8d4f4a$var$_interopRequireDefault((parcelRequire("42omo")));

var $aaf5f0417c8d4f4a$var$_baseNew = $aaf5f0417c8d4f4a$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $aaf5f0417c8d4f4a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "FolderOpen".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for open folders in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $aaf5f0417c8d4f4a$var$FolderOpenIcon = (props)=>/*#__PURE__*/ $aaf5f0417c8d4f4a$var$_react.default.createElement($aaf5f0417c8d4f4a$var$_baseNew.default, Object.assign({
        name: "FolderOpenIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 2.5a.5.5 0 0 0-.5.5v9.473L3.148 6.98c.174-.582.71-.98 1.317-.98H12.5V4.75a.5.5 0 0 0-.5-.5H6.69L4.94 2.5zM14 6h.66c.921 0 1.582.888 1.317 1.77l-1.741 5.805A2 2 0 0 1 12.32 15H1.75A1.75 1.75 0 0 1 0 13.25V3a2 2 0 0 1 2-2h3.56l1.75 1.75H12a2 2 0 0 1 2 2zM2.758 13.5h9.562a.5.5 0 0 0 .479-.356L14.492 7.5H4.558z" clip-rule="evenodd"/>`
    }, props));
$aaf5f0417c8d4f4a$var$FolderOpenIcon.displayName = 'FolderOpenIcon';
var $aaf5f0417c8d4f4a$var$_default = module.exports.default = $aaf5f0417c8d4f4a$var$FolderOpenIcon;

});

parcelRegister("gWb8i", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fe74ef9c654d922d3ff18f7784d24df9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c54ab2dc9b4306d4$var$_react = $c54ab2dc9b4306d4$var$_interopRequireDefault((parcelRequire("42omo")));

var $c54ab2dc9b4306d4$var$_baseNew = $c54ab2dc9b4306d4$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $c54ab2dc9b4306d4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Glasses".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: Changing tone of written content to Educational with Atlassian Intelligence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c54ab2dc9b4306d4$var$GlassesIcon = (props)=>/*#__PURE__*/ $c54ab2dc9b4306d4$var$_react.default.createElement($c54ab2dc9b4306d4$var$_baseNew.default, Object.assign({
        name: "GlassesIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m4.81 2.433-1.804.82c-.353.16-.599.491-.65.876l-.433 3.245A3.5 3.5 0 0 1 3.5 7c1.184 0 2.23.587 2.863 1.486A3 3 0 0 1 8 8c.604 0 1.167.179 1.637.486A3.5 3.5 0 0 1 12.5 7c.567 0 1.103.135 1.577.374l-.433-3.245a1.13 1.13 0 0 0-.65-.876l-1.804-.82.62-1.366 1.805.82A2.63 2.63 0 0 1 15.13 3.93l.76 5.697A3.505 3.505 0 0 1 12.5 14a3.5 3.5 0 0 1-3.453-4.074A1.5 1.5 0 0 0 8 9.5c-.407 0-.776.162-1.047.426q.046.281.047.574a3.5 3.5 0 1 1-6.89-.873L.87 3.93a2.63 2.63 0 0 1 1.515-2.042l1.805-.82zM1.5 10.546a2 2 0 1 0 .083-.617zm12.917-.617.082.617a2 2 0 1 1-.082-.617" clip-rule="evenodd"/>`
    }, props));
$c54ab2dc9b4306d4$var$GlassesIcon.displayName = 'GlassesIcon';
var $c54ab2dc9b4306d4$var$_default = module.exports.default = $c54ab2dc9b4306d4$var$GlassesIcon;

});

parcelRegister("74Ajl", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0180dbb14c91e16176b90c5ab90f56c2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $526512b5af86da90$var$_react = $526512b5af86da90$var$_interopRequireDefault((parcelRequire("42omo")));

var $526512b5af86da90$var$_baseNew = $526512b5af86da90$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $526512b5af86da90$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Highlight".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for highlight text tool in Confluence Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $526512b5af86da90$var$HighlightIcon = (props)=>/*#__PURE__*/ $526512b5af86da90$var$_react.default.createElement($526512b5af86da90$var$_baseNew.default, Object.assign({
        name: "HighlightIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M10.516.31a1.375 1.375 0 0 1 1.76.155l1.259 1.26c.471.47.537 1.212.155 1.759L9.365 9.679a.75.75 0 0 1-.363.277l-3.5 1.25a.75.75 0 0 1-.782-.176l-.095-.094-.595.594a.75.75 0 0 1-1.06 0l-.5-.5a.75.75 0 0 1 0-1.06l.594-.595-.094-.095a.75.75 0 0 1-.176-.782l1.25-3.5a.75.75 0 0 1 .277-.363zm.773 1.29L5.913 5.353l2.734 2.734L12.4 2.71zM7.382 8.942 5.058 6.618l-.692 1.937 1.079 1.08z" clip-rule="evenodd"/>`
    }, props));
$526512b5af86da90$var$HighlightIcon.displayName = 'HighlightIcon';
var $526512b5af86da90$var$_default = module.exports.default = $526512b5af86da90$var$HighlightIcon;

});

parcelRegister("2tC8Z", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9192cbdac48cc13a6ba11749984434b1>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1cdbe0d39b1aea2b$var$_react = $1cdbe0d39b1aea2b$var$_interopRequireDefault((parcelRequire("42omo")));

var $1cdbe0d39b1aea2b$var$_baseNew = $1cdbe0d39b1aea2b$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $1cdbe0d39b1aea2b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ImageInline".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for representing inline images in Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $1cdbe0d39b1aea2b$var$ImageInlineIcon = (props)=>/*#__PURE__*/ $1cdbe0d39b1aea2b$var$_react.default.createElement($1cdbe0d39b1aea2b$var$_baseNew.default, Object.assign({
        name: "ImageInlineIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 6.375C0 5.615.616 5 1.375 5h3.25C5.385 5 6 5.616 6 6.375v3.25C6 10.385 5.384 11 4.625 11h-3.25C.615 11 0 10.384 0 9.625zm1.5.125v3h3v-3zM16 8.75H8v-1.5h8z" clip-rule="evenodd"/>`
    }, props));
$1cdbe0d39b1aea2b$var$ImageInlineIcon.displayName = 'ImageInlineIcon';
var $1cdbe0d39b1aea2b$var$_default = module.exports.default = $1cdbe0d39b1aea2b$var$ImageInlineIcon;

});

parcelRegister("6V1ly", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::45707d9c52fa683c21ac6061fb8f413e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $50991c5e8073eaa1$var$_react = $50991c5e8073eaa1$var$_interopRequireDefault((parcelRequire("42omo")));

var $50991c5e8073eaa1$var$_baseNew = $50991c5e8073eaa1$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $50991c5e8073eaa1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Pin".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: unpinned fields.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $50991c5e8073eaa1$var$PinIcon = (props)=>/*#__PURE__*/ $50991c5e8073eaa1$var$_react.default.createElement($50991c5e8073eaa1$var$_baseNew.default, Object.assign({
        name: "PinIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M5.354 0a1.376 1.376 0 0 0-1.268 1.908l.089.174L5 3.458v3.475a5 5 0 0 0-1.184.61C2.898 8.195 2 9.348 2 11.25c0 .414.336.75.75.75h4.5v4h1.5v-4h4.5a.75.75 0 0 0 .75-.75c0-1.903-.898-3.056-1.816-3.706A5 5 0 0 0 11 6.933V3.458l.825-1.376A1.375 1.375 0 0 0 10.647 0zm4.252 2.864a.75.75 0 0 0-.106.386V7.5c0 .367.265.68.627.74l.008.001.066.016a3.4 3.4 0 0 1 1.115.512c.463.327.938.852 1.113 1.731H3.57c.175-.88.65-1.404 1.113-1.731a3.4 3.4 0 0 1 1.181-.528l.008-.002A.75.75 0 0 0 6.5 7.5V3.25a.75.75 0 0 0-.106-.386L5.574 1.5h4.852z"/>`
    }, props));
$50991c5e8073eaa1$var$PinIcon.displayName = 'PinIcon';
var $50991c5e8073eaa1$var$_default = module.exports.default = $50991c5e8073eaa1$var$PinIcon;

});

parcelRegister("4CxKE", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::acec4781ecabd39ce0fe49f50749e4d4>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $35d4e45efa8d5118$var$_react = $35d4e45efa8d5118$var$_interopRequireDefault((parcelRequire("42omo")));

var $35d4e45efa8d5118$var$_baseNew = $35d4e45efa8d5118$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $35d4e45efa8d5118$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Shapes".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for shapes in Whiteboards.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $35d4e45efa8d5118$var$ShapesIcon = (props)=>/*#__PURE__*/ $35d4e45efa8d5118$var$_react.default.createElement($35d4e45efa8d5118$var$_baseNew.default, Object.assign({
        name: "ShapesIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M15 2.38C15 1.62 14.38 1 13.63 1h-3.25C9.62 1 9 1.62 9 2.38v3.25C9 6.39 9.62 7 10.38 7h3.25C14.39 7 15 6.38 15 5.63zm-1.5.13v3h-3v-3zM3.13 1.26a1 1 0 0 1 1.74 0l2.57 4.5a1 1 0 0 1-.87 1.5H1.43a1 1 0 0 1-.87-1.5zM4 2.76 2.29 5.75h3.42zM.75 12a3.25 3.25 0 1 1 6.5 0 3.25 3.25 0 0 1-6.5 0M4 10.25a1.75 1.75 0 1 0 0 3.5 1.75 1.75 0 0 0 0-3.5M10 9h4.25a.75.75 0 0 1 .75.75V14h-1.5v-2.44l-3.72 3.72-1.06-1.06 3.72-3.72H10z" clip-rule="evenodd"/>`
    }, props));
$35d4e45efa8d5118$var$ShapesIcon.displayName = 'ShapesIcon';
var $35d4e45efa8d5118$var$_default = module.exports.default = $35d4e45efa8d5118$var$ShapesIcon;

});

parcelRegister("duwSm", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f4d5f161589a38033248db2607dbad0d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9d2794231a9e8f40$var$_react = $9d2794231a9e8f40$var$_interopRequireDefault((parcelRequire("42omo")));

var $9d2794231a9e8f40$var$_baseNew = $9d2794231a9e8f40$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $9d2794231a9e8f40$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "SmartLink".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for representing Smart links.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9d2794231a9e8f40$var$SmartLinkIcon = (props)=>/*#__PURE__*/ $9d2794231a9e8f40$var$_react.default.createElement($9d2794231a9e8f40$var$_baseNew.default, Object.assign({
        name: "SmartLinkIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M9.117 1.547a3.933 3.933 0 0 1 4.663 6.234l-2.25 2.25-1.06-1.061 2.25-2.25a2.432 2.432 0 0 0-2.604-3.986q.132.361.134.766a2.25 2.25 0 1 1-1.133-1.953M8 2.75a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5M2.22 8.22l2.25-2.25 1.06 1.06-2.25 2.25a2.432 2.432 0 0 0 2.604 3.987 2.25 2.25 0 1 1 .998 1.187A3.933 3.933 0 0 1 2.22 8.22M8 11.75a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5" clip-rule="evenodd"/>`
    }, props));
$9d2794231a9e8f40$var$SmartLinkIcon.displayName = 'SmartLinkIcon';
var $9d2794231a9e8f40$var$_default = module.exports.default = $9d2794231a9e8f40$var$SmartLinkIcon;

});

parcelRegister("99wB5", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b41205595ae662eed4f6fa7d0da6a5f2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6a9e3d71ec5c1936$var$_react = $6a9e3d71ec5c1936$var$_interopRequireDefault((parcelRequire("42omo")));

var $6a9e3d71ec5c1936$var$_baseNew = $6a9e3d71ec5c1936$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $6a9e3d71ec5c1936$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "SmartLinkEmbed".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for representing Smart link embeds.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6a9e3d71ec5c1936$var$SmartLinkEmbedIcon = (props)=>/*#__PURE__*/ $6a9e3d71ec5c1936$var$_react.default.createElement($6a9e3d71ec5c1936$var$_baseNew.default, Object.assign({
        name: "SmartLinkEmbedIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v4h11V3a.5.5 0 0 0-.5-.5zm10.5 6h-11V13a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5zm-8-3H4V4h1.5zm6.5 0H7V4h5z" clip-rule="evenodd"/>`
    }, props));
$6a9e3d71ec5c1936$var$SmartLinkEmbedIcon.displayName = 'SmartLinkEmbedIcon';
var $6a9e3d71ec5c1936$var$_default = module.exports.default = $6a9e3d71ec5c1936$var$SmartLinkEmbedIcon;

});

parcelRegister("4c0se", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::61f2cd3b3ce75546535a34edc6c6a407>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $30d8a2a999090609$var$_react = $30d8a2a999090609$var$_interopRequireDefault((parcelRequire("42omo")));

var $30d8a2a999090609$var$_baseNew = $30d8a2a999090609$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $30d8a2a999090609$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "SortAscending".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for sorting data.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $30d8a2a999090609$var$SortAscendingIcon = (props)=>/*#__PURE__*/ $30d8a2a999090609$var$_react.default.createElement($30d8a2a999090609$var$_baseNew.default, Object.assign({
        name: "SortAscendingIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M15 12.5H1V14h14zm-1.75-3.75V3.56l1.72 1.72 1.06-1.06-3-3a.75.75 0 0 0-1.06 0l-3 3 1.06 1.06 1.72-1.72v5.19zM8 7.25H1v1.5h7zM6 2H1v1.5h5z" clip-rule="evenodd"/>`
    }, props));
$30d8a2a999090609$var$SortAscendingIcon.displayName = 'SortAscendingIcon';
var $30d8a2a999090609$var$_default = module.exports.default = $30d8a2a999090609$var$SortAscendingIcon;

});

parcelRegister("bh5s2", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b50a6e4dd8b62d7d7bf2cfae0d8c6979>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $835582ba87108709$var$_react = $835582ba87108709$var$_interopRequireDefault((parcelRequire("42omo")));

var $835582ba87108709$var$_baseNew = $835582ba87108709$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $835582ba87108709$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusVerified".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for representing verified content.
Filled status icons provide higher visual contrast draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $835582ba87108709$var$StatusVerifiedIcon = (props)=>/*#__PURE__*/ $835582ba87108709$var$_react.default.createElement($835582ba87108709$var$_baseNew.default, Object.assign({
        name: "StatusVerifiedIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.85.444a1.713 1.713 0 0 1 2.301 0L10.3 1.486a.2.2 0 0 0 .15.055L12 1.48a1.71 1.71 0 0 1 1.762 1.479l.21 1.537a.2.2 0 0 0 .081.139l1.226.95c.696.54.87 1.52.4 2.266l-.828 1.312a.2.2 0 0 0-.027.158l.328 1.516a1.713 1.713 0 0 1-1.151 1.993l-1.477.474a.2.2 0 0 0-.123.103l-.723 1.372a1.713 1.713 0 0 1-2.162.787l-1.435-.587a.2.2 0 0 0-.161 0l-1.436.587a1.713 1.713 0 0 1-2.162-.787l-.723-1.372a.22.22 0 0 0-.124-.103L2 12.83a1.713 1.713 0 0 1-1.15-1.993l.327-1.516a.2.2 0 0 0-.027-.158L.322 7.852a1.713 1.713 0 0 1 .4-2.266l1.225-.95a.2.2 0 0 0 .081-.14l.21-1.536a1.71 1.71 0 0 1 1.763-1.48l1.55.06a.2.2 0 0 0 .15-.055zm-.1 9.384L4.826 7.519l-1.152.961 2.5 3a.75.75 0 0 0 1.152 0l5-6-1.152-.96z" clip-rule="evenodd"/>`
    }, props));
$835582ba87108709$var$StatusVerifiedIcon.displayName = 'StatusVerifiedIcon';
var $835582ba87108709$var$_default = module.exports.default = $835582ba87108709$var$StatusVerifiedIcon;

});

parcelRegister("kR5QY", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8c7bb68234d60992450ed6f02b59a5e8>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f2ed4c3c0db31f3a$var$_react = $f2ed4c3c0db31f3a$var$_interopRequireDefault((parcelRequire("42omo")));

var $f2ed4c3c0db31f3a$var$_baseNew = $f2ed4c3c0db31f3a$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $f2ed4c3c0db31f3a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Story".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for story work type.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f2ed4c3c0db31f3a$var$StoryIcon = (props)=>/*#__PURE__*/ $f2ed4c3c0db31f3a$var$_react.default.createElement($f2ed4c3c0db31f3a$var$_baseNew.default, Object.assign({
        name: "StoryIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M11.518 3a.5.5 0 0 0-.5-.5H4.983a.5.5 0 0 0-.5.5v9.806L8 10.333l.431.304 3.087 2.169zm1.5 11.202a.776.776 0 0 1-1.122.694l-.099-.06L8 12.166l-3.796 2.67a.775.775 0 0 1-1.22-.634V3a2 2 0 0 1 2-2h6.035a2 2 0 0 1 2 2z"/>`
    }, props));
$f2ed4c3c0db31f3a$var$StoryIcon.displayName = 'StoryIcon';
var $f2ed4c3c0db31f3a$var$_default = module.exports.default = $f2ed4c3c0db31f3a$var$StoryIcon;

});

parcelRegister("4nv4H", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::10d7615b6292d70e1de86f8e11f4b3be>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $33016a337ebb928a$var$_react = $33016a337ebb928a$var$_interopRequireDefault((parcelRequire("42omo")));

var $33016a337ebb928a$var$_baseNew = $33016a337ebb928a$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $33016a337ebb928a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TableCellSplit".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for splitting joined table cells.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $33016a337ebb928a$var$TableCellSplitIcon = (props)=>/*#__PURE__*/ $33016a337ebb928a$var$_react.default.createElement($33016a337ebb928a$var$_baseNew.default, Object.assign({
        name: "TableCellSplitIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M5 3.5H0V2h5a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H0v-1.5h5a.5.5 0 0 0 .5-.5V4a.5.5 0 0 0-.5-.5m6 0a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h5V14h-5a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h5v1.5zM.22 7.47l2.25-2.25 1.06 1.06L1.81 8l1.72 1.72-1.06 1.06L.22 8.53a.75.75 0 0 1 0-1.06M14.19 8l-1.72-1.72 1.06-1.06 2.25 2.25a.75.75 0 0 1 0 1.06l-2.25 2.25-1.06-1.06z" clip-rule="evenodd"/>`
    }, props));
$33016a337ebb928a$var$TableCellSplitIcon.displayName = 'TableCellSplitIcon';
var $33016a337ebb928a$var$_default = module.exports.default = $33016a337ebb928a$var$TableCellSplitIcon;

});

parcelRegister("lvYQd", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4462f40c375ebe722466dce1677f33d8>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fa9bb0018e2157d5$var$_react = $fa9bb0018e2157d5$var$_interopRequireDefault((parcelRequire("42omo")));

var $fa9bb0018e2157d5$var$_baseNew = $fa9bb0018e2157d5$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $fa9bb0018e2157d5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TableColumnMoveLeft".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for moving a table column to the left of its current location.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $fa9bb0018e2157d5$var$TableColumnMoveLeftIcon = (props)=>/*#__PURE__*/ $fa9bb0018e2157d5$var$_react.default.createElement($fa9bb0018e2157d5$var$_baseNew.default, Object.assign({
        name: "TableColumnMoveLeftIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M16 2.375C16 1.615 15.384 1 14.625 1h-5.75C8.115 1 7.5 1.616 7.5 2.375v11.25c0 .76.616 1.375 1.375 1.375h5.75c.76 0 1.375-.616 1.375-1.375zm-1.5.125v11h-2v-11zm-3.5 0v11H9v-11zM3.22 4.47l-3 3a.75.75 0 0 0 0 1.06l3 3 1.06-1.06-1.72-1.72H6v-1.5H2.56l1.72-1.72z" clip-rule="evenodd"/>`
    }, props));
$fa9bb0018e2157d5$var$TableColumnMoveLeftIcon.displayName = 'TableColumnMoveLeftIcon';
var $fa9bb0018e2157d5$var$_default = module.exports.default = $fa9bb0018e2157d5$var$TableColumnMoveLeftIcon;

});

parcelRegister("iBNSQ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7cda528f9679d716d7f767e6ce4137c1>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d8c26089cc549354$var$_react = $d8c26089cc549354$var$_interopRequireDefault((parcelRequire("42omo")));

var $d8c26089cc549354$var$_baseNew = $d8c26089cc549354$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $d8c26089cc549354$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TableColumnsDistribute".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for distributing the width of table columns evenly.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d8c26089cc549354$var$TableColumnsDistributeIcon = (props)=>/*#__PURE__*/ $d8c26089cc549354$var$_react.default.createElement($d8c26089cc549354$var$_baseNew.default, Object.assign({
        name: "TableColumnsDistributeIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 2.375C2 1.615 2.616 1 3.375 1h9.25C13.385 1 14 1.616 14 2.375v11.25c0 .76-.616 1.375-1.375 1.375h-9.25C2.615 15 2 14.384 2 13.625zm1.5.125v11h2v-11zm3.5 0v11h2v-11zm3.5 0v11h2v-11z" clip-rule="evenodd"/>`
    }, props));
$d8c26089cc549354$var$TableColumnsDistributeIcon.displayName = 'TableColumnsDistributeIcon';
var $d8c26089cc549354$var$_default = module.exports.default = $d8c26089cc549354$var$TableColumnsDistributeIcon;

});

parcelRegister("4s9K9", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::18326ccc0c26c72e4df39b65b2150728>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $33e155cc01343bee$var$_react = $33e155cc01343bee$var$_interopRequireDefault((parcelRequire("42omo")));

var $33e155cc01343bee$var$_baseNew = $33e155cc01343bee$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $33e155cc01343bee$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TableRowAddBelow".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for adding a table row below the selected row.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $33e155cc01343bee$var$TableRowAddBelowIcon = (props)=>/*#__PURE__*/ $33e155cc01343bee$var$_react.default.createElement($33e155cc01343bee$var$_baseNew.default, Object.assign({
        name: "TableRowAddBelowIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2.375 0C1.615 0 1 .616 1 1.375v5.75c0 .76.616 1.375 1.375 1.375h11.25c.76 0 1.375-.616 1.375-1.375v-5.75C15 .615 14.384 0 13.625 0zM2.5 1.5h11v2h-11zm0 3.5h11v2h-11zm6.25 7.25H11v1.5H8.75V16h-1.5v-2.25H5v-1.5h2.25V10h1.5z" clip-rule="evenodd"/>`
    }, props));
$33e155cc01343bee$var$TableRowAddBelowIcon.displayName = 'TableRowAddBelowIcon';
var $33e155cc01343bee$var$_default = module.exports.default = $33e155cc01343bee$var$TableRowAddBelowIcon;

});

parcelRegister("HbwpQ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a47975d9a6c646363e74cea370b39b9e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $081cf44386c6c160$var$_react = $081cf44386c6c160$var$_interopRequireDefault((parcelRequire("42omo")));

var $081cf44386c6c160$var$_baseNew = $081cf44386c6c160$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $081cf44386c6c160$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TableRowDelete".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for deleting a table row.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $081cf44386c6c160$var$TableRowDeleteIcon = (props)=>/*#__PURE__*/ $081cf44386c6c160$var$_react.default.createElement($081cf44386c6c160$var$_baseNew.default, Object.assign({
        name: "TableRowDeleteIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2.375 0C1.615 0 1 .616 1 1.375v5.75c0 .76.616 1.375 1.375 1.375h11.25c.76 0 1.375-.616 1.375-1.375v-5.75C15 .615 14.384 0 13.625 0zM2.5 1.5h11v2h-11zm0 3.5h11v2h-11zm8.5 7.25H5v1.5h6z" clip-rule="evenodd"/>`
    }, props));
$081cf44386c6c160$var$TableRowDeleteIcon.displayName = 'TableRowDeleteIcon';
var $081cf44386c6c160$var$_default = module.exports.default = $081cf44386c6c160$var$TableRowDeleteIcon;

});

parcelRegister("krMwx", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9e12ad8b9285399e621f8347da1513c6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ee2bf81396e7c3b9$var$_react = $ee2bf81396e7c3b9$var$_interopRequireDefault((parcelRequire("42omo")));

var $ee2bf81396e7c3b9$var$_baseNew = $ee2bf81396e7c3b9$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $ee2bf81396e7c3b9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TableRowMoveDown".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for moving a table row below its current location.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ee2bf81396e7c3b9$var$TableRowMoveDownIcon = (props)=>/*#__PURE__*/ $ee2bf81396e7c3b9$var$_react.default.createElement($ee2bf81396e7c3b9$var$_baseNew.default, Object.assign({
        name: "TableRowMoveDownIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2.375 0C1.615 0 1 .616 1 1.375v5.75c0 .76.616 1.375 1.375 1.375h11.25c.76 0 1.375-.616 1.375-1.375v-5.75C15 .615 14.384 0 13.625 0zM2.5 1.5h11v2h-11zm0 3.5h11v2h-11zm1.97 7.78 3 3a.75.75 0 0 0 1.06 0l3-3-1.06-1.06-1.72 1.72V10h-1.5v3.44l-1.72-1.72z" clip-rule="evenodd"/>`
    }, props));
$ee2bf81396e7c3b9$var$TableRowMoveDownIcon.displayName = 'TableRowMoveDownIcon';
var $ee2bf81396e7c3b9$var$_default = module.exports.default = $ee2bf81396e7c3b9$var$TableRowMoveDownIcon;

});

parcelRegister("gzmk4", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::94299558fe30d8b873c5baac0be690ce>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c1013b07f72e2d0e$var$_react = $c1013b07f72e2d0e$var$_interopRequireDefault((parcelRequire("42omo")));

var $c1013b07f72e2d0e$var$_baseNew = $c1013b07f72e2d0e$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $c1013b07f72e2d0e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TableRowMoveUp".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for moving a table row above its current location.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c1013b07f72e2d0e$var$TableRowMoveUpIcon = (props)=>/*#__PURE__*/ $c1013b07f72e2d0e$var$_react.default.createElement($c1013b07f72e2d0e$var$_baseNew.default, Object.assign({
        name: "TableRowMoveUpIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2.375 16C1.615 16 1 15.384 1 14.625v-5.75c0-.76.616-1.375 1.375-1.375h11.25c.76 0 1.375.616 1.375 1.375v5.75c0 .76-.616 1.375-1.375 1.375zm.125-1.5h11v-2h-11zm0-3.5h11V9h-11zm1.97-7.78 3-3a.75.75 0 0 1 1.06 0l3 3-1.06 1.06-1.72-1.72V6h-1.5V2.56L5.53 4.28z" clip-rule="evenodd"/>`
    }, props));
$c1013b07f72e2d0e$var$TableRowMoveUpIcon.displayName = 'TableRowMoveUpIcon';
var $c1013b07f72e2d0e$var$_default = module.exports.default = $c1013b07f72e2d0e$var$TableRowMoveUpIcon;

});

parcelRegister("f8c3d", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5e4d05a25c478251d31315596858be41>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b040f3715618c2b7$var$_react = $b040f3715618c2b7$var$_interopRequireDefault((parcelRequire("42omo")));

var $b040f3715618c2b7$var$_baseNew = $b040f3715618c2b7$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $b040f3715618c2b7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Text".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for representing text objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b040f3715618c2b7$var$TextIcon = (props)=>/*#__PURE__*/ $b040f3715618c2b7$var$_react.default.createElement($b040f3715618c2b7$var$_baseNew.default, Object.assign({
        name: "TextIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4.813 2.5H0V1h11v1.5H6.313V15h-1.5zM12 6.5V4h1.5v2.5H16V8h-2.5v5a.5.5 0 0 0 .5.5h2V15h-2a2 2 0 0 1-2-2V8h-2V6.5z" clip-rule="evenodd"/>`
    }, props));
$b040f3715618c2b7$var$TextIcon.displayName = 'TextIcon';
var $b040f3715618c2b7$var$_default = module.exports.default = $b040f3715618c2b7$var$TextIcon;

});

parcelRegister("dLjaJ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::20df9865399d0da64293437f5db358c1>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a04e89575dd798d3$var$_react = $a04e89575dd798d3$var$_interopRequireDefault((parcelRequire("42omo")));

var $a04e89575dd798d3$var$_baseNew = $a04e89575dd798d3$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $a04e89575dd798d3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TextSpellcheck".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for spellchecking.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a04e89575dd798d3$var$TextSpellcheckIcon = (props)=>/*#__PURE__*/ $a04e89575dd798d3$var$_react.default.createElement($a04e89575dd798d3$var$_baseNew.default, Object.assign({
        name: "TextSpellcheckIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4.67.494A.75.75 0 0 1 5.375 0h.75a.75.75 0 0 1 .705.494l3.625 10a.8.8 0 0 1 .045.256V11H9.06l-.015.006L9.043 11H9v-.118L7.955 8h-4.41L2.5 10.882V11h-.043l-.002.006L2.44 11H1v-.25a.8.8 0 0 1 .045-.256zM4.088 6.5h3.324L5.75 1.916z" clip-rule="evenodd"/><path fill="currentcolor" fill-rule="evenodd" d="m13.928 9.265 1.144.97-4.667 5.5a.75.75 0 0 1-1.144 0l-2.333-2.75 1.144-.97 1.761 2.076z" clip-rule="evenodd"/>`
    }, props));
$a04e89575dd798d3$var$TextSpellcheckIcon.displayName = 'TextSpellcheckIcon';
var $a04e89575dd798d3$var$_default = module.exports.default = $a04e89575dd798d3$var$TextSpellcheckIcon;

});

parcelRegister("jHpAD", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d4892c276b5463761a4363f071816684>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e575e217847495ac$var$_react = $e575e217847495ac$var$_interopRequireDefault((parcelRequire("42omo")));

var $e575e217847495ac$var$_baseNew = $e575e217847495ac$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $e575e217847495ac$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TextStrikethrough".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for strikethrough text tool
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e575e217847495ac$var$TextStrikethroughIcon = (props)=>/*#__PURE__*/ $e575e217847495ac$var$_react.default.createElement($e575e217847495ac$var$_baseNew.default, Object.assign({
        name: "TextStrikethroughIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M7.47 2.5a2.12 2.12 0 0 0-1.79 3.25H4.03a3.59 3.59 0 0 1 .5-3.25A3.62 3.62 0 0 1 7.47 1h.93a4.08 4.08 0 0 1 3.19 1.53l-1.17.94A2.58 2.58 0 0 0 8.4 2.5zm3.51 7.75h1.58A3.82 3.82 0 0 1 8.86 15h-.67a4.5 4.5 0 0 1-4.11-2.67l-.01-.02 1.37-.61.01.02a3 3 0 0 0 2.74 1.78h.67a2.32 2.32 0 0 0 2.12-3.25m4.02-3H1v1.5h14z"/>`
    }, props));
$e575e217847495ac$var$TextStrikethroughIcon.displayName = 'TextStrikethroughIcon';
var $e575e217847495ac$var$_default = module.exports.default = $e575e217847495ac$var$TextStrikethroughIcon;

});

parcelRegister("4E5My", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1e6328b238b4e1d4c8883ade823798f3>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $361f62118221568e$var$_react = $361f62118221568e$var$_interopRequireDefault((parcelRequire("42omo")));

var $361f62118221568e$var$_baseNew = $361f62118221568e$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $361f62118221568e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TextUnderline".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for underlined text tool
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $361f62118221568e$var$TextUnderlineIcon = (props)=>/*#__PURE__*/ $361f62118221568e$var$_react.default.createElement($361f62118221568e$var$_baseNew.default, Object.assign({
        name: "TextUnderlineIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M3.5 8V1H5v7a3 3 0 0 0 6 0V1h1.5v7a4.5 4.5 0 1 1-9 0M0 16v-1.5h16V16z" clip-rule="evenodd"/>`
    }, props));
$361f62118221568e$var$TextUnderlineIcon.displayName = 'TextUnderlineIcon';
var $361f62118221568e$var$_default = module.exports.default = $361f62118221568e$var$TextUnderlineIcon;

});

parcelRegister("aK2ZC", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d2eb42ffff47552bf7695cd1247757bc>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7d20859794a36c61$var$_react = $7d20859794a36c61$var$_interopRequireDefault((parcelRequire("42omo")));

var $7d20859794a36c61$var$_baseNew = $7d20859794a36c61$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $7d20859794a36c61$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TextWrap".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for wrapping text so it spans multiple lines.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7d20859794a36c61$var$TextWrapIcon = (props)=>/*#__PURE__*/ $7d20859794a36c61$var$_react.default.createElement($7d20859794a36c61$var$_baseNew.default, Object.assign({
        name: "TextWrapIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M13.375 5H0V3.5h13.375A2.625 2.625 0 0 1 16 6.125v2.75a2.625 2.625 0 0 1-2.625 2.625H9.561l1.72 1.72-1.061 1.06-3-3a.75.75 0 0 1 0-1.06l3-3 1.06 1.06L9.56 10h3.815c.621 0 1.125-.504 1.125-1.125v-2.75C14.5 5.504 13.996 5 13.375 5M5 11.5H0V10h5z" clip-rule="evenodd"/>`
    }, props));
$7d20859794a36c61$var$TextWrapIcon.displayName = 'TextWrapIcon';
var $7d20859794a36c61$var$_default = module.exports.default = $7d20859794a36c61$var$TextWrapIcon;

});

parcelRegister("9zIwY", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::20d0f335103d15624fb4f6fc4abbdad2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6f89ecda342ba131$var$_react = $6f89ecda342ba131$var$_interopRequireDefault((parcelRequire("42omo")));

var $6f89ecda342ba131$var$_baseNew = $6f89ecda342ba131$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $6f89ecda342ba131$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ThumbsDown".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: voting, feedback in AI.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6f89ecda342ba131$var$ThumbsDownIcon = (props)=>/*#__PURE__*/ $6f89ecda342ba131$var$_react.default.createElement($6f89ecda342ba131$var$_baseNew.default, Object.assign({
        name: "ThumbsDownIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M7.292 13.406a.5.5 0 0 0 .77-.15l2.438-4.69V2.5H4.128c-.492 0-.927.32-1.073.79L1.726 7.54A1.125 1.125 0 0 0 2.8 9h3.45a.75.75 0 0 1 .75.75v3.175a.5.5 0 0 0 .174.38zM12 2.5V8h2a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5zm-.295 7-2.313 4.45a2 2 0 0 1-3.076.596l-.118-.101a2 2 0 0 1-.698-1.519V10.5H2.8A2.625 2.625 0 0 1 .295 7.092l1.328-4.25A2.625 2.625 0 0 1 4.128 1H14a2 2 0 0 1 2 2v4.5a2 2 0 0 1-2 2z" clip-rule="evenodd"/>`
    }, props));
$6f89ecda342ba131$var$ThumbsDownIcon.displayName = 'ThumbsDownIcon';
var $6f89ecda342ba131$var$_default = module.exports.default = $6f89ecda342ba131$var$ThumbsDownIcon;

});

parcelRegister("5lVpa", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d776e090c71d4272dea1a04d82939ee2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3e5b7151f1fdca09$var$_react = $3e5b7151f1fdca09$var$_interopRequireDefault((parcelRequire("42omo")));

var $3e5b7151f1fdca09$var$_baseNew = $3e5b7151f1fdca09$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $3e5b7151f1fdca09$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "VideoStopOverlay".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for stopping video content. Use on dark or translucent backgrounds.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3e5b7151f1fdca09$var$VideoStopOverlayIcon = (props)=>/*#__PURE__*/ $3e5b7151f1fdca09$var$_react.default.createElement($3e5b7151f1fdca09$var$_baseNew.default, Object.assign({
        name: "VideoStopOverlayIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5z" clip-rule="evenodd"/><path fill="currentcolor" d="M2.5 3a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 .5.5v10a.5.5 0 0 1-.5.5H3a.5.5 0 0 1-.5-.5z"/>`
    }, props));
$3e5b7151f1fdca09$var$VideoStopOverlayIcon.displayName = 'VideoStopOverlayIcon';
var $3e5b7151f1fdca09$var$_default = module.exports.default = $3e5b7151f1fdca09$var$VideoStopOverlayIcon;

});

parcelRegister("ZDq1z", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::63bc83d2df21e8aa09401170cfaa4b9a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0b94465cb6c9f0e8$var$_react = $0b94465cb6c9f0e8$var$_interopRequireDefault((parcelRequire("42omo")));

var $0b94465cb6c9f0e8$var$_baseNew = $0b94465cb6c9f0e8$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $0b94465cb6c9f0e8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Whiteboard".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for whiteboards in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0b94465cb6c9f0e8$var$WhiteboardIcon = (props)=>/*#__PURE__*/ $0b94465cb6c9f0e8$var$_react.default.createElement($0b94465cb6c9f0e8$var$_baseNew.default, Object.assign({
        name: "WhiteboardIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M9.162 2.177c-.714.282-1.28.817-1.449 1.338l-1.426-.463C6.637 1.97 7.633 1.168 8.61.782c.943-.372 2.248-.49 3.09.375.346.356.536.777.548 1.236.011.437-.14.827-.323 1.144-.228.394-.557.761-.876 1.074 1.466-.136 2.717.239 3.421 1.134.827 1.05.644 2.464-.256 3.697l-1.212-.884c.66-.905.556-1.547.29-1.885-.305-.387-1.095-.757-2.524-.512-.521.09-.935.138-1.236.13a1.4 1.4 0 0 1-.537-.11.9.9 0 0 1-.345-.278.85.85 0 0 1-.164-.495 1.02 1.02 0 0 1 .197-.586c.077-.112.171-.215.256-.3.14-.143.323-.306.499-.464l.101-.09c.453-.407.87-.806 1.087-1.181.102-.178.124-.292.123-.354-.002-.04-.01-.113-.124-.23-.2-.204-.716-.321-1.464-.026M3.75 5.5a2.25 2.25 0 1 0 0 4.5 2.25 2.25 0 0 0 0-4.5M0 7.75a3.75 3.75 0 1 1 7.5 0 3.75 3.75 0 0 1-7.5 0m10.25.75a.75.75 0 0 1 .643.364l3 5A.75.75 0 0 1 13.25 15h-6a.75.75 0 0 1-.643-1.136l3-5a.75.75 0 0 1 .643-.364m-1.675 5h3.35l-1.675-2.792z" clip-rule="evenodd"/>`
    }, props));
$0b94465cb6c9f0e8$var$WhiteboardIcon.displayName = 'WhiteboardIcon';
var $0b94465cb6c9f0e8$var$_default = module.exports.default = $0b94465cb6c9f0e8$var$WhiteboardIcon;

});

parcelRegister("SZOxu", function(module, exports) {
const $0cf93e9d3df78fcc$export$c647cb0ee6e282fe = {
    small: '16px',
    medium: '24px',
    large: '32px',
    xlarge: '48px'
};
const $0cf93e9d3df78fcc$export$7bd66fc94c81bf84 = {
    small: 'small',
    medium: 'medium',
    large: 'large',
    xlarge: 'xlarge'
};
const $0cf93e9d3df78fcc$export$62ad7b0c781000e9 = {
    small: {
        width: $0cf93e9d3df78fcc$export$c647cb0ee6e282fe.small,
        height: $0cf93e9d3df78fcc$export$c647cb0ee6e282fe.small
    },
    medium: {
        width: $0cf93e9d3df78fcc$export$c647cb0ee6e282fe.medium,
        height: $0cf93e9d3df78fcc$export$c647cb0ee6e282fe.medium
    },
    large: {
        width: $0cf93e9d3df78fcc$export$c647cb0ee6e282fe.large,
        height: $0cf93e9d3df78fcc$export$c647cb0ee6e282fe.large
    },
    xlarge: {
        width: $0cf93e9d3df78fcc$export$c647cb0ee6e282fe.xlarge,
        height: $0cf93e9d3df78fcc$export$c647cb0ee6e282fe.xlarge
    }
};
module.exports["sizes"] = $0cf93e9d3df78fcc$export$c647cb0ee6e282fe;
module.exports["sizeMap"] = $0cf93e9d3df78fcc$export$7bd66fc94c81bf84;

});

parcelRegister("1kWtu", function(module, exports) {
/* skeleton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $9be428c9cd9a24d6$var$skeletonStyles = null;
const $9be428c9cd9a24d6$var$subtleOpacityStyles = null;
const $9be428c9cd9a24d6$var$strongOpacityStyles = null;
const $9be428c9cd9a24d6$var$sizeStyles = {
    small: "_1bsb7vkz _4t3i7vkz",
    medium: "_1bsb1tcg _4t3i1tcg",
    large: "_1bsbzwfg _4t3izwfg",
    xlarge: "_1bsbckbl _4t3ickbl"
}; /**
    * __Skeleton__
    */ 
const $9be428c9cd9a24d6$var$Skeleton = /*#__PURE__*/ (0, $42omo.memo)(function Skeleton({ testId: testId, size: size = 'medium', color: color = 'currentColor', weight: weight = 'normal' }) {
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        "data-testid": testId,
        style: {
            backgroundColor: color
        },
        className: (0, $gMc0m.default)([
            "_2rko1qll _1e0c1o8l",
            weight === 'strong' ? "_tzy4clii" : "_tzy4nh7s",
            $9be428c9cd9a24d6$var$sizeStyles[size]
        ])
    });
});
var $9be428c9cd9a24d6$export$2e2bcd8739ae039 = $9be428c9cd9a24d6$var$Skeleton;
module.exports["default"] = $9be428c9cd9a24d6$export$2e2bcd8739ae039;

});

parcelRegister("lE8sM", function(module, exports) {
$parcel$export(module.exports, "default", () => $c4115a2d35a14dc8$export$2e2bcd8739ae039);

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $dh538 = parcelRequire("dh538");


var $eCcCl = parcelRequire("eCcCl");


var $1boGo = parcelRequire("1boGo");

// Color mapping for size 16 standalone icons that will no longer be tiles
const $c4115a2d35a14dc8$var$appearanceToIconColorMap = {
    blue: "var(--ds-icon-accent-blue, #357DE8)",
    blueBold: "var(--ds-icon-accent-blue, #357DE8)",
    gray: "var(--ds-icon-accent-gray, #7D818A)",
    grayBold: "var(--ds-icon-accent-gray, #7D818A)",
    green: "var(--ds-icon-accent-green, #22A06B)",
    greenBold: "var(--ds-icon-accent-green, #22A06B)",
    lime: "var(--ds-icon-accent-lime, #6A9A23)",
    limeBold: "var(--ds-icon-accent-lime, #6A9A23)",
    magenta: "var(--ds-icon-accent-magenta, #CD519D)",
    magentaBold: "var(--ds-icon-accent-magenta, #CD519D)",
    orange: "var(--ds-icon-accent-orange, #E06C00)",
    orangeBold: "var(--ds-icon-accent-orange, #E06C00)",
    purple: "var(--ds-icon-accent-purple, #AF59E1)",
    purpleBold: "var(--ds-icon-accent-purple, #AF59E1)",
    red: "var(--ds-icon-accent-red, #C9372C)",
    redBold: "var(--ds-icon-accent-red, #C9372C)",
    teal: "var(--ds-icon-accent-teal, #2898BD)",
    tealBold: "var(--ds-icon-accent-teal, #2898BD)",
    yellow: "var(--ds-icon-accent-yellow, #B38600)",
    yellowBold: "var(--ds-icon-accent-yellow, #B38600)"
};
function $c4115a2d35a14dc8$export$2e2bcd8739ae039({ appearance: appearance, icon: Icon, label: label, size: size, testId: testId, shape: shape, UNSAFE_circleReplacementComponent: UNSAFE_circleReplacementComponent }) {
    if (UNSAFE_circleReplacementComponent && shape === 'circle' && ((0, $dh538.fg)('platform_dst_icon_tile_circle_replacement') || (0, $dh538.fg)('platform_dst_icon_tile_circle_replacement_stage2'))) return UNSAFE_circleReplacementComponent;
    if (shape !== 'circle' && ((0, $dh538.fg)('platform_dst_new_icon_tile') || (0, $dh538.fg)('platform_dst_new_icon_tile_stage2'))) {
        // Handle size 16 - render icon directly without Tile
        if (size === '16') return /*#__PURE__*/ (0, $l998X.jsx)(Icon, {
            color: $c4115a2d35a14dc8$var$appearanceToIconColorMap[appearance],
            label: label,
            testId: testId
        });
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $eCcCl.default), {
            appearance: appearance,
            icon: Icon,
            label: label,
            shape: shape,
            size: size,
            testId: testId
        });
    }
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $1boGo.default), {
        appearance: appearance,
        icon: Icon,
        label: label,
        shape: shape,
        size: size,
        testId: testId
    });
}

});


$parcel$global.rlb("6wr18")
//# sourceMappingURL=vendors~editor_icon.d614ee58.js.map
